"use strict";

/* ============================================================
   ORDER TRACKING i18n — La Boutique du Bracelet
   13 langues : fr, de, en, da, es, el, it, nl, pl, pt, ro, sv, cs
   ============================================================ */

/* ---- Parcel Panel : retirer le premier transporteur uniquement sur la page de suivi ---- */
(function scopeParcelPanelCarrierCleanup() {
  var trackingRoot = document.querySelector('.lbdb-tracking-wrapper');
  if (!trackingRoot || typeof MutationObserver === 'undefined') return;

  function hideFirstCarrierBlock(scope) {
    var trackingBlocks = [];

    if (scope.matches && scope.matches('.pp_tracking_info_parent')) {
      trackingBlocks.push(scope);
    }

    if (scope.querySelectorAll) {
      trackingBlocks = trackingBlocks.concat(Array.from(scope.querySelectorAll('.pp_tracking_info_parent')));
    }

    trackingBlocks.forEach(function (trackingBlock) {
      var carriers = trackingBlock.querySelectorAll('.PP-SectionItem.PP-Section-CarrierInfo');

      if (carriers.length >= 2 && !carriers[0].dataset.hiddenCarrier) {
        carriers[0].style.display = 'none';
        carriers[0].dataset.hiddenCarrier = 'true';
      }
    });
  }

  hideFirstCarrierBlock(trackingRoot);

  var parcelObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (addedNode) {
        if (addedNode.nodeType === Node.ELEMENT_NODE) {
          hideFirstCarrierBlock(addedNode);
        }
      });
    });
  });

  parcelObserver.observe(trackingRoot, { childList: true, subtree: true });
})();

var LBDB_I18N = {
  /* ─── FRANÇAIS (défaut) ─── */
  fr: {
    locale_date: 'fr-FR',
    /* Étapes */
    step_1_title: 'Commande confirmée',
    step_1_desc: 'Merci pour votre confiance ! Votre paiement est validé et votre commande enregistrée.',
    step_2_title: 'Préparation en cours',
    step_2_desc: 'Votre commande est en cours de préparation par notre équipe. Elle sera expédiée très prochainement.',
    step_3_title: 'Colis expédié',
    step_3_desc: 'Votre commande a été expédiée ! Vous pouvez désormais suivre son parcours pas à pas.',
    step_4_title: 'Colis pris en charge',
    step_4_desc: 'Votre colis a été confié à notre transporteur et son suivi est maintenant actif.',
    step_5_title: 'En route vers vous',
    step_5_desc: 'Votre colis poursuit son chemin. Chaque étape le rapproche un peu plus de vous.',
    step_6_title: 'Acheminement en cours',
    step_6_desc: 'Votre colis avance étape par étape. Quelques jours peuvent s\'écouler entre deux mises à jour — c\'est tout à fait normal.',
    step_7_title: 'Arrivé près de chez vous',
    step_7_desc: 'Bonne nouvelle : votre colis vient d\'arriver dans votre région. Il entre dans la dernière phase de son parcours avant la livraison.',
    step_8_title: 'Dernière étape',
    step_8_desc: 'Nous effectuons un ultime contrôle pour nous assurer que votre colis vous parvienne dans les meilleures conditions. Plus que quelques étapes !',
    step_9_title: 'En route vers votre ville',
    step_9_desc: 'Votre colis se rapproche de votre adresse. La livraison approche à grands pas.',
    step_10_title: 'À deux pas de chez vous',
    step_10_desc: 'Votre colis est arrivé dans votre secteur de livraison. Votre livreur le récupèrera très prochainement — c\'est presque terminé !',
    step_11_title: 'Livraison en cours',
    step_11_desc: 'C\'est le grand jour : votre livreur est en tournée avec votre colis. Restez à proximité, votre commande arrive aujourd\'hui !',
    step_12_title: 'Votre commande est arrivée',
    step_12_desc: 'Votre commande a été livrée ! Nous espérons que votre bracelet vous plaira. Une question ? Notre équipe reste à votre écoute.',
    /* Badges */
    badge_transit: 'En chemin',
    badge_delivered: 'Livré',
    badge_preparing: 'En préparation',
    badge_priority: 'En réapprovisionnement',
    badge_shipped: 'Expédié',
    badge_pickup: 'Livraison en cours',
    badge_undelivered: 'Livraison à reprogrammer',
    badge_exception: 'Vérification en cours',
    badge_late: 'Retardé',
    badge_default: 'En cours',
    /* Pré-expédition */
    pre_preparing: 'Votre commande a bien été reçue et est en cours de préparation par notre équipe. Vous recevrez une notification dès l\'expédition.',
    pre_finalizing: 'Votre commande est en cours de finalisation avant expédition. Plus que quelques instants et votre colis sera en route.',
    pre_restock: 'Ce modèle rencontre un très fort succès et nos équipes finalisent votre commande avec la plus grande attention. La date estimée ci-dessus tient compte de ce délai.',
    pre_priority: 'Votre commande fait l\'objet d\'un traitement prioritaire : notre équipe suit personnellement son expédition. Un doute, une question ? Notre service client vous répond en priorité.',
    /* UI */
    order_placed_on: 'Passée le',
    estimated_delivery: 'Livraison estimée',
    progress_order: 'Commande',
    progress_delivery: 'Livraison',
    tracking_number_title: 'Votre numéro de suivi',
    tracking_btn: 'Suivre mon colis en temps réel →',
    last_update: 'Dernière mise à jour du réseau :',
    last_update_less_1h: 'il y a moins d\'une heure',
    last_update_hours: 'il y a {n}h',
    last_update_date: 'le',
    estimate_reminder: 'Livraison estimée : {date}',
    contact_question: 'Une question sur votre livraison ?',
    contact_link: 'Contactez notre service client',
    new_search: '← Suivre une autre commande',
    magic_banner: 'Accès sécurisé — vous êtes connecté directement via votre lien personnel.',
    error_invalid: 'Vérifiez vos informations.',
    error_token: 'Lien de suivi invalide ou expiré.',
    error_network: 'Impossible de contacter le service de suivi. Veuillez réessayer.',
    /* Modal annulation */
    cancel_intro: 'Ce délai est trop long ?',
    cancel_btn: 'Annuler ma commande',
    cancel_checking: 'Vérification en cours…',
    cancel_checking_text: 'Nous vérifions si votre commande peut encore être annulée.',
    cancel_title_priority: 'Annulation de votre commande',
    cancel_text_priority: 'Votre commande accuse un retard que nous regrettons. Elle est en traitement prioritaire et sera expédiée dès que possible. Vous pouvez l\'annuler et être remboursé intégralement si vous le souhaitez.',
    cancel_title_restock: 'Annulation de votre commande',
    cancel_text_restock: 'Votre commande est en cours de finalisation avant expédition. Vous pouvez l\'annuler et être remboursé intégralement à tout moment avant l\'expédition.',
    cancel_keep: 'Maintenir ma commande',
    cancel_confirm: 'Annuler et être remboursé',
    cancel_impossible: 'Annulation impossible',
    cancel_already_shipped: 'Votre commande est déjà en cours d\'expédition. Il n\'est plus possible de l\'annuler automatiquement.',
    cancel_not_found: 'Nous n\'avons pas trouvé votre commande dans notre système.',
    cancel_error_generic: 'Une erreur technique nous empêche de traiter votre demande pour le moment.',
    cancel_team_available: 'Notre équipe reste disponible pour vous aider.',
    cancel_contact: 'Contacter le support',
    cancel_close: 'Fermer',
    cancel_processing: 'Annulation en cours…',
    cancel_processing_text: 'Nous traitons votre demande, merci de patienter.',
    cancel_success: 'Commande annulée',
    cancel_success_text: 'Votre commande {order} a bien été annulée. Vous serez remboursé de {amount} {currency} sous 5 à 10 jours ouvrés.',
    cancel_failed: 'Annulation échouée',
    cancel_failed_text: 'Une erreur est survenue lors de l\'annulation. Notre équipe a été notifiée et vous contactera.',
    cancel_error_connection: 'Erreur de connexion',
    cancel_error_connection_text: 'Impossible de contacter notre service. Veuillez réessayer ou contacter le support.',
    cancel_error_finalize: 'Impossible de finaliser l\'annulation. Contactez notre support.',
    /* Textes statiques formulaire */
    page_title: 'Suivi de votre commande',
    page_subtitle: 'Retrouvez en temps réel l\'état d\'acheminement de votre bracelet.',
    form_title: 'Accéder à mon suivi',
    label_email: 'Adresse email',
    label_order: 'Numéro de commande',
    placeholder_email: 'votre@email.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Suivre ma commande',
    loader_title: 'Nous récupérons les dernières mises à jour de votre livraison…',
    loader_sub: 'Cela prend quelques secondes',
    loader_step2_msg: 'Vérification de votre commande…',
    loader_step3_msg: 'Analyse des données de suivi…',
    result_badge_default: 'En préparation',
    result_est_label: 'Livraison estimée',
    result_your_order: 'VOTRE COMMANDE',
    info_tip_delay: 'Les délais peuvent varier en fonction du transporteur.',
    result_progress_order: 'Commande',
    result_progress_delivery: 'Livraison',
    result_tn_title: 'Votre numéro de suivi',
    result_tn_btn: 'Suivre mon colis en temps réel →',
    result_timeline_title: 'Progression de votre commande',
    result_help: 'Une question sur votre livraison ?',
    result_help_link: 'Contactez notre service client',
    result_new_search: '← Suivre une autre commande',
    delay_transit_late: 'Vos bracelets préférés ont eu un succès fou et nous avons dû nous réapprovisionner pour vous les envoyer. Votre colis est maintenant en route ! Merci infiniment pour votre patience et votre confiance.',
    delivered_on: 'Livré le {date}',
    cs_same_info: 'Vous voyez les mêmes informations sur le statut de votre commande que celles auxquelles nos agents du service client peuvent accéder.',
    at_latest: 'au plus tard le',
    countdown_days: 'Encore environ {n} jours.',
    countdown_day: 'Livraison pr\u00e9vue demain.',
    countdown_today: 'Livraison pr\u00e9vue aujourd\u2019hui.',
    next_step_label: 'Prochaine \u00e9tape :',
    next_step_5: 'Acheminement vers votre r\u00e9gion.',
    next_step_6: 'Arriv\u00e9e au centre de tri.',
    next_step_7: 'Remise \u00e0 votre transporteur local.',
    next_step_8: 'Prise en charge par votre transporteur.',
    next_step_9: 'Livraison \u00e0 votre adresse.',
    next_step_10: 'Votre livreur prend en charge votre colis.',
    next_step_11: 'Livraison \u00e0 votre adresse.',
    faq_title: 'Questions fr\u00e9quentes',
    faq_q1: 'Pourquoi mon suivi ne bouge plus ?',
    faq_a1: 'Les transporteurs ne scannent pas les colis \u00e0 chaque \u00e9tape. Il est normal qu\u2019aucune mise \u00e0 jour n\u2019apparaisse pendant 2 \u00e0 5 jours.',
    faq_q2: 'Ma commande peut-elle arriver plus t\u00f4t ?',
    faq_a2: 'Oui, c\u2019est possible ! Nous faisons toujours notre maximum pour vous livrer dans les meilleurs d\u00e9lais.',
    faq_q3: 'Que faire si je ne suis pas disponible ?',
    faq_a3: 'Le transporteur laissera un avis de passage ou votre colis sera d\u00e9pos\u00e9 en point relais selon le service choisi.',
    faq_q4: 'Puis-je annuler ma commande ?',
    faq_a4: 'Une fois votre commande expédiée, il n’est plus possible de l’annuler. Vous pourrez effectuer un retour gratuit après réception.',
    sav_help: 'Besoin d\u2019aide ? Notre \u00e9quipe r\u00e9pond sous 24h (jours ouvr\u00e9s).',
    patience_scan_imminent: 'Mise à jour imminente — votre colis progresse normalement.',
    patience_scan_hours: 'Prochaine mise à jour attendue dans les prochaines heures.',
    patience_scan_day: 'Prochaine mise à jour attendue d\u2019ici {day} soir.',
    patience_benchmark: 'Les commandes arrivent en moyenne en {avg} jours. La vôtre est en route depuis {days} jours.',
    patience_reassurance: '{pct}% des commandes arrivent dans les délais estimés.',
    patience_scan_overdue: 'Le scan attendu n\u2019est pas encore arriv\u00e9 \u2014 cela concerne {pct}% des colis \u00e0 cette \u00e9tape, sans impact sur la date de livraison estim\u00e9e.',
    patience_reason_flight: 'les colis ne sont pas scann\u00e9s entre deux centres de tri.',
    patience_reason_hub: 'le traitement au centre de tri peut prendre quelques heures.',
    patience_reason_local: 'votre transporteur local proc\u00e8de aux scans de distribution.'
  },
  /* ─── ALLEMAND ─── */
  de: {
    locale_date: 'de-DE',
    step_1_title: 'Bestellung bestätigt',
    step_1_desc: 'Vielen Dank für Ihr Vertrauen! Ihre Zahlung wurde bestätigt und Ihre Bestellung registriert.',
    step_2_title: 'In Vorbereitung',
    step_2_desc: 'Ihre Bestellung wird von unserem Team vorbereitet. Sie wird in Kürze versendet.',
    step_3_title: 'Paket versendet',
    step_3_desc: 'Ihre Bestellung wurde versendet! Sie können den Weg Ihres Pakets nun Schritt für Schritt verfolgen.',
    step_4_title: 'Paket übernommen',
    step_4_desc: 'Ihr Paket wurde unserem Transportdienst übergeben und die Sendungsverfolgung ist aktiv.',
    step_5_title: 'Auf dem Weg zu Ihnen',
    step_5_desc: 'Ihr Paket ist unterwegs. Jeder Schritt bringt es näher zu Ihnen.',
    step_6_title: 'Transport läuft',
    step_6_desc: 'Ihr Paket wird Etappe für Etappe weitergeleitet. Zwischen zwei Aktualisierungen können einige Tage vergehen — das ist völlig normal.',
    step_7_title: 'In Ihrer Nähe angekommen',
    step_7_desc: 'Gute Nachricht: Ihr Paket ist in Ihrer Region angekommen. Es befindet sich in der letzten Phase vor der Zustellung.',
    step_8_title: 'Letzte Etappe',
    step_8_desc: 'Wir führen eine letzte Kontrolle durch, um sicherzustellen, dass Ihr Paket in bestem Zustand bei Ihnen ankommt. Nur noch wenige Schritte!',
    step_9_title: 'Auf dem Weg in Ihre Stadt',
    step_9_desc: 'Ihr Paket nähert sich Ihrer Adresse. Die Zustellung steht kurz bevor.',
    step_10_title: 'Fast bei Ihnen',
    step_10_desc: 'Ihr Paket ist in Ihrem Zustellgebiet angekommen. Ihr Zusteller wird es in Kürze abholen — es ist fast geschafft!',
    step_11_title: 'Zustellung läuft',
    step_11_desc: 'Heute ist der große Tag: Ihr Zusteller ist mit Ihrem Paket unterwegs. Bleiben Sie in der Nähe, Ihre Bestellung kommt heute an!',
    step_12_title: 'Ihre Bestellung ist angekommen',
    step_12_desc: 'Ihre Bestellung wurde zugestellt! Wir hoffen, dass Ihnen Ihr Armband gefällt. Eine Frage? Unser Team steht Ihnen zur Verfügung.',
    badge_transit: 'Unterwegs',
    badge_delivered: 'Zugestellt',
    badge_preparing: 'In Vorbereitung',
    badge_priority: 'Nachbestellung',
    badge_shipped: 'Versendet',
    badge_pickup: 'Zustellung läuft',
    badge_undelivered: 'Zustellung neu planen',
    badge_exception: 'Überprüfung läuft',
    badge_late: 'Verspätet',
    badge_default: 'In Bearbeitung',
    pre_preparing: 'Ihre Bestellung wurde erfolgreich empfangen und wird von unserem Team vorbereitet. Sie erhalten eine Benachrichtigung, sobald sie versendet wird.',
    pre_finalizing: 'Ihre Bestellung wird vor dem Versand finalisiert. In wenigen Augenblicken ist Ihr Paket unterwegs.',
    pre_restock: 'Dieses Modell ist sehr beliebt und unser Team bereitet Ihre Bestellung mit größter Sorgfalt vor. Das geschätzte Datum oben berücksichtigt diese Verzögerung.',
    pre_priority: 'Ihre Bestellung wird vorrangig bearbeitet: Unser Team verfolgt den Versand persönlich. Eine Frage? Unser Kundenservice antwortet Ihnen vorrangig.',
    order_placed_on: 'Bestellt am',
    estimated_delivery: 'Voraussichtliche Lieferung',
    progress_order: 'Bestellung',
    progress_delivery: 'Lieferung',
    tracking_number_title: 'Ihre Sendungsnummer',
    tracking_btn: 'Paket in Echtzeit verfolgen →',
    last_update: 'Letzte Netzwerk-Aktualisierung:',
    last_update_less_1h: 'vor weniger als einer Stunde',
    last_update_hours: 'vor {n} Std.',
    last_update_date: 'am',
    estimate_reminder: 'Voraussichtliche Lieferung: {date}',
    contact_question: 'Eine Frage zu Ihrer Lieferung?',
    contact_link: 'Kontaktieren Sie unseren Kundenservice',
    new_search: '← Andere Bestellung verfolgen',
    magic_banner: 'Sicherer Zugang — Sie sind über Ihren persönlichen Link verbunden.',
    error_invalid: 'Bitte überprüfen Sie Ihre Angaben.',
    error_token: 'Ungültiger oder abgelaufener Tracking-Link.',
    error_network: 'Der Tracking-Service ist derzeit nicht erreichbar. Bitte versuchen Sie es erneut.',
    cancel_intro: 'Dauert es zu lange?',
    cancel_btn: 'Bestellung stornieren',
    cancel_checking: 'Überprüfung läuft…',
    cancel_checking_text: 'Wir prüfen, ob Ihre Bestellung noch storniert werden kann.',
    cancel_title_priority: 'Stornierung Ihrer Bestellung',
    cancel_text_priority: 'Ihre Bestellung hat eine Verzögerung, die wir bedauern. Sie wird vorrangig bearbeitet und so schnell wie möglich versendet. Sie können sie stornieren und eine vollständige Rückerstattung erhalten.',
    cancel_title_restock: 'Stornierung Ihrer Bestellung',
    cancel_text_restock: 'Ihre Bestellung wird vor dem Versand finalisiert. Sie können sie jederzeit vor dem Versand stornieren und eine vollständige Rückerstattung erhalten.',
    cancel_keep: 'Bestellung beibehalten',
    cancel_confirm: 'Stornieren und erstatten',
    cancel_impossible: 'Stornierung nicht möglich',
    cancel_already_shipped: 'Ihre Bestellung wird bereits versendet. Eine automatische Stornierung ist nicht mehr möglich.',
    cancel_not_found: 'Wir konnten Ihre Bestellung nicht in unserem System finden.',
    cancel_error_generic: 'Ein technischer Fehler verhindert die Bearbeitung Ihrer Anfrage.',
    cancel_team_available: 'Unser Team steht Ihnen gerne zur Verfügung.',
    cancel_contact: 'Support kontaktieren',
    cancel_close: 'Schließen',
    cancel_processing: 'Stornierung läuft…',
    cancel_processing_text: 'Wir bearbeiten Ihre Anfrage, bitte haben Sie Geduld.',
    cancel_success: 'Bestellung storniert',
    cancel_success_text: 'Ihre Bestellung {order} wurde erfolgreich storniert. Die Rückerstattung von {amount} {currency} erfolgt innerhalb von 5 bis 10 Werktagen.',
    cancel_failed: 'Stornierung fehlgeschlagen',
    cancel_failed_text: 'Bei der Stornierung ist ein Fehler aufgetreten. Unser Team wurde benachrichtigt und wird sich bei Ihnen melden.',
    cancel_error_connection: 'Verbindungsfehler',
    cancel_error_connection_text: 'Unser Service ist derzeit nicht erreichbar. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.',
    cancel_error_finalize: 'Die Stornierung konnte nicht abgeschlossen werden. Bitte kontaktieren Sie unseren Support.',
    page_title: 'Sendungsverfolgung',
    page_subtitle: 'Verfolgen Sie den aktuellen Status Ihres Armbands in Echtzeit.',
    form_title: 'Meine Sendung verfolgen',
    label_email: 'E-Mail-Adresse',
    label_order: 'Bestellnummer',
    placeholder_email: 'ihre@email.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Bestellung verfolgen',
    loader_title: 'Wir rufen die neuesten Updates Ihrer Lieferung ab…',
    loader_sub: 'Dies dauert einige Sekunden',
    loader_step2_msg: 'Überprüfung Ihrer Bestellung…',
    loader_step3_msg: 'Analyse der Sendungsdaten…',
    result_badge_default: 'In Vorbereitung',
    result_est_label: 'Voraussichtliche Lieferung',
    result_your_order: 'IHRE BESTELLUNG',
    info_tip_delay: 'Die Lieferzeiten können je nach Transporteur variieren.',
    result_progress_order: 'Bestellung',
    result_progress_delivery: 'Lieferung',
    result_tn_title: 'Ihre Sendungsnummer',
    result_tn_btn: 'Paket in Echtzeit verfolgen →',
    result_timeline_title: 'Fortschritt Ihrer Bestellung',
    result_help: 'Eine Frage zu Ihrer Lieferung?',
    result_help_link: 'Kontaktieren Sie unseren Kundenservice',
    result_new_search: '← Andere Bestellung verfolgen',
    delay_transit_late: 'Ihre Lieblingsarmbänder waren so beliebt, dass wir unseren Bestand auffüllen mussten, bevor wir sie Ihnen zusenden konnten. Ihr Paket ist jetzt unterwegs! Vielen Dank für Ihre Geduld und Ihr Vertrauen.',
    delivered_on: 'Zugestellt am {date}',
    cs_same_info: 'Sie sehen dieselben Informationen zum Bestellstatus, auf die auch unsere Kundenservice-Mitarbeiter zugreifen können.',
    at_latest: 'sp\u00e4testens am',
    countdown_days: 'Noch etwa {n} Tage.',
    countdown_day: 'Lieferung voraussichtlich morgen.',
    countdown_today: 'Lieferung voraussichtlich heute.',
    next_step_label: 'N\u00e4chster Schritt:',
    next_step_5: 'Transport in Ihre Region.',
    next_step_6: 'Ankunft im Verteilzentrum.',
    next_step_7: '\u00dcbergabe an Ihren lokalen Zusteller.',
    next_step_8: '\u00dcbernahme durch Ihren Zusteller.',
    next_step_9: 'Zustellung an Ihre Adresse.',
    next_step_10: 'Ihr Zusteller \u00fcbernimmt Ihr Paket.',
    next_step_11: 'Zustellung an Ihre Adresse.',
    faq_title: 'H\u00e4ufige Fragen',
    faq_q1: 'Warum bewegt sich meine Sendungsverfolgung nicht?',
    faq_a1: 'Transportunternehmen scannen Pakete nicht bei jedem Schritt. Es ist normal, dass 2 bis 5 Tage lang keine Aktualisierung erscheint.',
    faq_q2: 'Kann meine Bestellung fr\u00fcher ankommen?',
    faq_a2: 'Ja, das ist m\u00f6glich! Wir tun immer unser Bestes, um so schnell wie m\u00f6glich zu liefern.',
    faq_q3: 'Was passiert, wenn ich nicht zu Hause bin?',
    faq_a3: 'Der Zusteller hinterl\u00e4sst eine Benachrichtigung oder Ihr Paket wird an eine Abholstation geliefert.',
    faq_q4: 'Kann ich meine Bestellung stornieren?',
    faq_a4: 'Sobald Ihre Bestellung versandt wurde, ist eine Stornierung nicht mehr möglich. Nach Erhalt können Sie eine kostenlose Rücksendung veranlassen.',
    sav_help: 'Brauchen Sie Hilfe? Unser Team antwortet innerhalb von 24 Stunden (Werktage).',
    patience_scan_imminent: 'Update steht unmittelbar bevor — Ihr Paket ist unterwegs.',
    patience_scan_hours: 'Nächstes Update wird in den nächsten Stunden erwartet.',
    patience_scan_day: 'Nächstes Update erwartet bis {day} Abend.',
    patience_benchmark: 'Bestellungen kommen im Durchschnitt in {avg} Tagen an. Ihre ist seit {days} Tagen unterwegs.',
    patience_reassurance: '{pct}% der Bestellungen kommen innerhalb der geschätzten Lieferzeit an.',
    patience_scan_overdue: 'Das erwartete Update ist noch nicht eingetroffen \u2014 das betrifft {pct}% der Pakete in dieser Phase, ohne Auswirkung auf das gesch\u00e4tzte Lieferdatum.',
    patience_reason_flight: 'Pakete werden zwischen Verteilzentren nicht gescannt.',
    patience_reason_hub: 'die Bearbeitung im Verteilzentrum kann einige Stunden dauern.',
    patience_reason_local: 'Ihr lokaler Zusteller f\u00fchrt die Verteilscans durch.'
  },
  /* ─── ANGLAIS ─── */
  en: {
    locale_date: 'en-GB',
    step_1_title: 'Order confirmed',
    step_1_desc: 'Thank you for your trust! Your payment has been confirmed and your order registered.',
    step_2_title: 'Being prepared',
    step_2_desc: 'Your order is being prepared by our team. It will be shipped very soon.',
    step_3_title: 'Parcel shipped',
    step_3_desc: 'Your order has been shipped! You can now track its journey step by step.',
    step_4_title: 'Parcel picked up',
    step_4_desc: 'Your parcel has been handed over to our carrier and tracking is now active.',
    step_5_title: 'On its way to you',
    step_5_desc: 'Your parcel is on its way. Each step brings it closer to you.',
    step_6_title: 'In transit',
    step_6_desc: 'Your parcel is progressing step by step. A few days may pass between updates — this is perfectly normal.',
    step_7_title: 'Arrived in your area',
    step_7_desc: 'Great news: your parcel has arrived in your region. It is entering the final phase before delivery.',
    step_8_title: 'Final check',
    step_8_desc: 'We are performing a final check to ensure your parcel arrives in the best condition. Just a few more steps!',
    step_9_title: 'Heading to your city',
    step_9_desc: 'Your parcel is getting closer to your address. Delivery is approaching fast.',
    step_10_title: 'Almost there',
    step_10_desc: 'Your parcel has arrived in your delivery area. Your courier will pick it up very soon — it\'s almost done!',
    step_11_title: 'Out for delivery',
    step_11_desc: 'Today is the day: your courier is out with your parcel. Stay nearby, your order arrives today!',
    step_12_title: 'Your order has arrived',
    step_12_desc: 'Your order has been delivered! We hope you love your bracelet. Any questions? Our team is here for you.',
    badge_transit: 'In transit',
    badge_delivered: 'Delivered',
    badge_preparing: 'Being prepared',
    badge_priority: 'Restocking',
    badge_shipped: 'Shipped',
    badge_pickup: 'Out for delivery',
    badge_undelivered: 'Delivery to reschedule',
    badge_exception: 'Under review',
    badge_late: 'Delayed',
    badge_default: 'In progress',
    pre_preparing: 'Your order has been received and is being prepared by our team. You will receive a notification once it ships.',
    pre_finalizing: 'Your order is being finalised before shipping. Your parcel will be on its way in just a moment.',
    pre_restock: 'This model is extremely popular and our team is preparing your order with the greatest care. The estimated date above accounts for this delay.',
    pre_priority: 'Your order is being given priority treatment: our team is personally tracking its shipment. Any questions? Our customer service will respond to you as a priority.',
    order_placed_on: 'Placed on',
    estimated_delivery: 'Estimated delivery',
    progress_order: 'Order',
    progress_delivery: 'Delivery',
    tracking_number_title: 'Your tracking number',
    tracking_btn: 'Track my parcel in real time →',
    last_update: 'Last network update:',
    last_update_less_1h: 'less than an hour ago',
    last_update_hours: '{n}h ago',
    last_update_date: 'on',
    estimate_reminder: 'Estimated delivery: {date}',
    contact_question: 'A question about your delivery?',
    contact_link: 'Contact our customer service',
    new_search: '← Track another order',
    magic_banner: 'Secure access — you are connected via your personal link.',
    error_invalid: 'Please check your details.',
    error_token: 'Invalid or expired tracking link.',
    error_network: 'Unable to reach the tracking service. Please try again.',
    cancel_intro: 'Taking too long?',
    cancel_btn: 'Cancel my order',
    cancel_checking: 'Checking…',
    cancel_checking_text: 'We are checking if your order can still be cancelled.',
    cancel_title_priority: 'Cancel your order',
    cancel_text_priority: 'Your order is experiencing a delay that we regret. It is being given priority treatment and will be shipped as soon as possible. You can cancel it and receive a full refund if you wish.',
    cancel_title_restock: 'Cancel your order',
    cancel_text_restock: 'Your order is being finalised before shipping. You can cancel it and receive a full refund at any time before it ships.',
    cancel_keep: 'Keep my order',
    cancel_confirm: 'Cancel and get refund',
    cancel_impossible: 'Cancellation not possible',
    cancel_already_shipped: 'Your order is already being shipped. Automatic cancellation is no longer possible.',
    cancel_not_found: 'We could not find your order in our system.',
    cancel_error_generic: 'A technical error is preventing us from processing your request at this time.',
    cancel_team_available: 'Our team is available to help you.',
    cancel_contact: 'Contact support',
    cancel_close: 'Close',
    cancel_processing: 'Cancelling…',
    cancel_processing_text: 'We are processing your request, please wait.',
    cancel_success: 'Order cancelled',
    cancel_success_text: 'Your order {order} has been successfully cancelled. You will be refunded {amount} {currency} within 5 to 10 business days.',
    cancel_failed: 'Cancellation failed',
    cancel_failed_text: 'An error occurred during cancellation. Our team has been notified and will contact you.',
    cancel_error_connection: 'Connection error',
    cancel_error_connection_text: 'Unable to reach our service. Please try again or contact support.',
    cancel_error_finalize: 'Unable to complete the cancellation. Please contact our support.',
    page_title: 'Track your order',
    page_subtitle: 'Track the delivery status of your bracelet in real time.',
    form_title: 'Access my tracking',
    label_email: 'Email address',
    label_order: 'Order number',
    placeholder_email: 'your@email.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Track my order',
    loader_title: 'We are retrieving the latest updates on your delivery…',
    loader_sub: 'This takes a few seconds',
    loader_step2_msg: 'Verifying your order…',
    loader_step3_msg: 'Analyzing tracking data…',
    result_badge_default: 'Being prepared',
    result_est_label: 'Estimated delivery',
    result_your_order: 'YOUR ORDER',
    info_tip_delay: 'Delivery times may vary depending on the carrier.',
    result_progress_order: 'Order',
    result_progress_delivery: 'Delivery',
    result_tn_title: 'Your tracking number',
    result_tn_btn: 'Track my parcel in real time →',
    result_timeline_title: 'Order progress',
    result_help: 'A question about your delivery?',
    result_help_link: 'Contact our customer service',
    result_new_search: '← Track another order',
    delay_transit_late: 'Your favourite bracelets have been incredibly popular and we had to restock before shipping yours. Your package is now on its way! Thank you so much for your patience and trust.',
    delivered_on: 'Delivered on {date}',
    cs_same_info: 'You are viewing the same order status information that our customer service agents can access.',
    at_latest: 'at the latest by',
    countdown_days: 'About {n} days remaining.',
    countdown_day: 'Delivery expected tomorrow.',
    countdown_today: 'Delivery expected today.',
    next_step_label: 'Next step:',
    next_step_5: 'In transit to your area.',
    next_step_6: 'Arriving at sorting centre.',
    next_step_7: 'Handover to your local carrier.',
    next_step_8: 'Picked up by your carrier.',
    next_step_9: 'Delivery to your address.',
    next_step_10: 'Your driver is collecting your parcel.',
    next_step_11: 'Delivery to your address.',
    faq_title: 'Frequently asked questions',
    faq_q1: 'Why is my tracking not updating?',
    faq_a1: 'Carriers do not scan parcels at every step. It is normal for no update to appear for 2 to 5 days.',
    faq_q2: 'Can my order arrive sooner?',
    faq_a2: 'Yes, it\u2019s possible! We always do our best to deliver as quickly as possible.',
    faq_q3: 'What if I\u2019m not available for delivery?',
    faq_a3: 'The carrier will leave a notice or your parcel will be delivered to a pickup point.',
    faq_q4: 'Can I cancel my order?',
    faq_a4: 'Once your order has been shipped, it can no longer be cancelled. You can make a free return after delivery.',
    sav_help: 'Need help? Our team responds within 24 hours (business days).',
    patience_scan_imminent: 'Update coming soon — your parcel is progressing normally.',
    patience_scan_hours: 'Next update expected within the next few hours.',
    patience_scan_day: 'Next update expected by {day} evening.',
    patience_benchmark: 'Orders arrive in {avg} days on average. Yours has been on its way for {days} days.',
    patience_reassurance: '{pct}% of orders arrive within the estimated timeframe.',
    patience_scan_overdue: 'The expected scan has not arrived yet \u2014 this affects {pct}% of parcels at this stage, with no impact on the estimated delivery date.',
    patience_reason_flight: 'parcels are not scanned between sorting centres.',
    patience_reason_hub: 'processing at the sorting centre may take a few hours.',
    patience_reason_local: 'your local carrier is performing distribution scans.'
  },
  /* ─── DANOIS ─── */
  da: {
    locale_date: 'da-DK',
    step_1_title: 'Ordre bekræftet',
    step_1_desc: 'Tak for din tillid! Din betaling er bekræftet, og din ordre er registreret.',
    step_2_title: 'Under forberedelse',
    step_2_desc: 'Din ordre forberedes af vores team. Den vil blive afsendt meget snart.',
    step_3_title: 'Pakke afsendt',
    step_3_desc: 'Din ordre er afsendt! Du kan nu følge dens rejse trin for trin.',
    step_4_title: 'Pakke afhentet',
    step_4_desc: 'Din pakke er overdraget til vores transportør, og sporing er nu aktiv.',
    step_5_title: 'På vej til dig',
    step_5_desc: 'Din pakke er på vej. Hvert trin bringer den tættere på dig.',
    step_6_title: 'Under transport',
    step_6_desc: 'Din pakke bevæger sig trin for trin. Der kan gå nogle dage mellem opdateringer — det er helt normalt.',
    step_7_title: 'Ankommet i dit område',
    step_7_desc: 'Godt nyt: din pakke er ankommet til din region. Den er i den sidste fase før levering.',
    step_8_title: 'Sidste kontrol',
    step_8_desc: 'Vi udfører en sidste kontrol for at sikre, at din pakke ankommer i bedste stand. Kun få trin tilbage!',
    step_9_title: 'På vej til din by',
    step_9_desc: 'Din pakke nærmer sig din adresse. Leveringen er lige om hjørnet.',
    step_10_title: 'Næsten fremme',
    step_10_desc: 'Din pakke er ankommet til dit leveringsområde. Din bud henter den meget snart — det er næsten klaret!',
    step_11_title: 'Ude til levering',
    step_11_desc: 'I dag er dagen: din bud er på vej med din pakke. Bliv i nærheden, din ordre ankommer i dag!',
    step_12_title: 'Din ordre er ankommet',
    step_12_desc: 'Din ordre er leveret! Vi håber, du elsker dit armbånd. Spørgsmål? Vores team er her for dig.',
    badge_transit: 'Undervejs',
    badge_delivered: 'Leveret',
    badge_preparing: 'Under forberedelse',
    badge_priority: 'Genopfyldning',
    badge_shipped: 'Afsendt',
    badge_pickup: 'Ude til levering',
    badge_undelivered: 'Levering skal omplanlægges',
    badge_exception: 'Under gennemgang',
    badge_late: 'Forsinket',
    badge_default: 'I gang',
    pre_preparing: 'Din ordre er modtaget og forberedes af vores team. Du modtager en notifikation, når den afsendes.',
    pre_finalizing: 'Din ordre færdiggøres inden afsendelse. Din pakke er snart på vej.',
    pre_restock: 'Denne model er ekstremt populær, og vores team forbereder din ordre med den største omhu. Den estimerede dato ovenfor tager højde for denne forsinkelse.',
    pre_priority: 'Din ordre behandles med prioritet: vores team følger personligt dens forsendelse. Spørgsmål? Vores kundeservice svarer dig med prioritet.',
    order_placed_on: 'Bestilt den',
    estimated_delivery: 'Forventet levering',
    progress_order: 'Ordre',
    progress_delivery: 'Levering',
    tracking_number_title: 'Dit sporingsnummer',
    tracking_btn: 'Spor min pakke i realtid →',
    last_update: 'Seneste netværksopdatering:',
    last_update_less_1h: 'for mindre end en time siden',
    last_update_hours: 'for {n} timer siden',
    last_update_date: 'den',
    estimate_reminder: 'Forventet levering: {date}',
    contact_question: 'Et spørgsmål om din levering?',
    contact_link: 'Kontakt vores kundeservice',
    new_search: '← Spor en anden ordre',
    magic_banner: 'Sikker adgang — du er forbundet via dit personlige link.',
    error_invalid: 'Tjek venligst dine oplysninger.',
    error_token: 'Ugyldigt eller udløbet sporingslink.',
    error_network: 'Kan ikke nå sporingstjenesten. Prøv venligst igen.',
    cancel_intro: 'Tager det for lang tid?',
    cancel_btn: 'Annuller min ordre',
    cancel_checking: 'Kontrollerer…',
    cancel_checking_text: 'Vi tjekker, om din ordre stadig kan annulleres.',
    cancel_title_priority: 'Annullering af din ordre',
    cancel_text_priority: 'Din ordre er forsinket, hvilket vi beklager. Den behandles med prioritet og afsendes hurtigst muligt. Du kan annullere den og modtage fuld refusion.',
    cancel_title_restock: 'Annullering af din ordre',
    cancel_text_restock: 'Din ordre færdiggøres inden afsendelse. Du kan annullere den og modtage fuld refusion når som helst inden afsendelse.',
    cancel_keep: 'Behold min ordre',
    cancel_confirm: 'Annuller og få refusion',
    cancel_impossible: 'Annullering ikke mulig',
    cancel_already_shipped: 'Din ordre er allerede under forsendelse. Automatisk annullering er ikke længere mulig.',
    cancel_not_found: 'Vi kunne ikke finde din ordre i vores system.',
    cancel_error_generic: 'En teknisk fejl forhindrer os i at behandle din anmodning.',
    cancel_team_available: 'Vores team er tilgængeligt for at hjælpe dig.',
    cancel_contact: 'Kontakt support',
    cancel_close: 'Luk',
    cancel_processing: 'Annullerer…',
    cancel_processing_text: 'Vi behandler din anmodning, vent venligst.',
    cancel_success: 'Ordre annulleret',
    cancel_success_text: 'Din ordre {order} er blevet annulleret. Du vil blive refunderet {amount} {currency} inden for 5 til 10 hverdage.',
    cancel_failed: 'Annullering mislykkedes',
    cancel_failed_text: 'Der opstod en fejl under annulleringen. Vores team er underrettet og vil kontakte dig.',
    cancel_error_connection: 'Forbindelsesfejl',
    cancel_error_connection_text: 'Kan ikke nå vores service. Prøv igen eller kontakt support.',
    cancel_error_finalize: 'Kan ikke fuldføre annulleringen. Kontakt venligst vores support.',
    page_title: 'Spor din ordre',
    page_subtitle: 'Følg leveringsstatus for dit armbånd i realtid.',
    form_title: 'Adgang til min sporing',
    label_email: 'E-mailadresse',
    label_order: 'Ordrenummer',
    placeholder_email: 'din@email.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Spor min ordre',
    loader_title: 'Vi henter de seneste opdateringer om din levering…',
    loader_sub: 'Det tager et par sekunder',
    loader_step2_msg: 'Bekræfter din ordre…',
    loader_step3_msg: 'Analyserer sporingsdata…',
    result_badge_default: 'Under forberedelse',
    result_est_label: 'Forventet levering',
    result_your_order: 'DIN ORDRE',
    info_tip_delay: 'Leveringstider kan variere afhængigt af transportøren.',
    result_progress_order: 'Ordre',
    result_progress_delivery: 'Levering',
    result_tn_title: 'Dit sporingsnummer',
    result_tn_btn: 'Spor min pakke i realtid →',
    result_timeline_title: 'Ordrefremskridt',
    result_help: 'Et spørgsmål om din levering?',
    result_help_link: 'Kontakt vores kundeservice',
    result_new_search: '← Spor en anden ordre',
    delay_transit_late: 'Dine yndlingsarmbånd har været utroligt populære, og vi har måttet genopfylde lageret, før vi kunne sende dine. Din pakke er nu på vej! Tusind tak for din tålmodighed og tillid.',
    delivered_on: 'Leveret den {date}',
    cs_same_info: 'Du ser de samme ordrestatusoplysninger, som vores kundeservicemedarbejdere har adgang til.',
    at_latest: 'senest den',
    countdown_days: 'Cirka {n} dage tilbage.',
    countdown_day: 'Levering forventes i morgen.',
    countdown_today: 'Levering forventes i dag.',
    next_step_label: 'N\u00e6ste trin:',
    next_step_5: 'P\u00e5 vej til dit omr\u00e5de.',
    next_step_6: 'Ankomst til sorteringscentret.',
    next_step_7: 'Overdragelse til din lokale transport\u00f8r.',
    next_step_8: 'Afhentet af din transport\u00f8r.',
    next_step_9: 'Levering til din adresse.',
    next_step_10: 'Din chauff\u00f8r henter din pakke.',
    next_step_11: 'Levering til din adresse.',
    faq_title: 'Ofte stillede sp\u00f8rgsm\u00e5l',
    faq_q1: 'Hvorfor opdateres min sporing ikke?',
    faq_a1: 'Transport\u00f8rer scanner ikke pakker ved hvert trin. Det er normalt, at der ikke vises nogen opdatering i 2 til 5 dage.',
    faq_q2: 'Kan min bestilling ankomme hurtigere?',
    faq_a2: 'Ja, det er muligt! Vi g\u00f8r altid vores bedste for at levere s\u00e5 hurtigt som muligt.',
    faq_q3: 'Hvad hvis jeg ikke er hjemme?',
    faq_a3: 'Transport\u00f8ren efterlader en besked, eller din pakke leveres til et afhentningssted.',
    faq_q4: 'Kan jeg annullere min ordre?',
    faq_a4: 'Når din ordre er afsendt, kan den ikke længere annulleres. Du kan foretage en gratis returnering efter modtagelse.',
    sav_help: 'Brug for hj\u00e6lp? Vores team svarer inden for 24 timer (hverdage).',
    patience_scan_imminent: 'Opdatering kommer snart — din pakke er på vej.',
    patience_scan_hours: 'Næste opdatering forventes inden for de næste timer.',
    patience_scan_day: 'Næste opdatering forventes inden {day} aften.',
    patience_benchmark: 'Bestillinger ankommer i gennemsnit på {avg} dage. Din har været undervejs i {days} dage.',
    patience_reassurance: '{pct}% af bestillingerne ankommer inden for den estimerede leveringstid.',
    patience_scan_overdue: 'Den forventede scanning er endnu ikke ankommet \u2014 dette p\u00e5virker {pct}% af pakkerne p\u00e5 dette trin, uden indvirkning p\u00e5 den estimerede leveringsdato.',
    patience_reason_flight: 'pakker scannes ikke mellem sorteringscentre.',
    patience_reason_hub: 'behandlingen p\u00e5 sorteringscentret kan tage et par timer.',
    patience_reason_local: 'din lokale transport\u00f8r udf\u00f8rer distributionsscanninger.'
  },
  /* ─── ESPAGNOL ─── */
  es: {
    locale_date: 'es-ES',
    step_1_title: 'Pedido confirmado',
    step_1_desc: '¡Gracias por su confianza! Su pago ha sido confirmado y su pedido registrado.',
    step_2_title: 'En preparación',
    step_2_desc: 'Su pedido está siendo preparado por nuestro equipo. Será enviado muy pronto.',
    step_3_title: 'Paquete enviado',
    step_3_desc: '¡Su pedido ha sido enviado! Ahora puede seguir su recorrido paso a paso.',
    step_4_title: 'Paquete recogido',
    step_4_desc: 'Su paquete ha sido entregado a nuestro transportista y el seguimiento está activo.',
    step_5_title: 'En camino hacia usted',
    step_5_desc: 'Su paquete está en camino. Cada paso lo acerca más a usted.',
    step_6_title: 'En tránsito',
    step_6_desc: 'Su paquete avanza etapa por etapa. Pueden pasar algunos días entre actualizaciones — es perfectamente normal.',
    step_7_title: 'Llegó a su zona',
    step_7_desc: 'Buenas noticias: su paquete ha llegado a su región. Está en la fase final antes de la entrega.',
    step_8_title: 'Última verificación',
    step_8_desc: 'Estamos realizando una última verificación para asegurar que su paquete llegue en las mejores condiciones. ¡Solo unos pasos más!',
    step_9_title: 'En camino a su ciudad',
    step_9_desc: 'Su paquete se acerca a su dirección. La entrega está muy cerca.',
    step_10_title: 'Casi en su puerta',
    step_10_desc: 'Su paquete ha llegado a su zona de entrega. Su repartidor lo recogerá muy pronto — ¡ya casi está!',
    step_11_title: 'En reparto',
    step_11_desc: '¡Hoy es el día! Su repartidor está en ruta con su paquete. Permanezca cerca, ¡su pedido llega hoy!',
    step_12_title: 'Su pedido ha llegado',
    step_12_desc: '¡Su pedido ha sido entregado! Esperamos que le encante su pulsera. ¿Alguna pregunta? Nuestro equipo está a su disposición.',
    badge_transit: 'En camino',
    badge_delivered: 'Entregado',
    badge_preparing: 'En preparación',
    badge_priority: 'Reabastecimiento',
    badge_shipped: 'Enviado',
    badge_pickup: 'En reparto',
    badge_undelivered: 'Entrega a reprogramar',
    badge_exception: 'En verificación',
    badge_late: 'Retrasado',
    badge_default: 'En curso',
    pre_preparing: 'Su pedido ha sido recibido y está siendo preparado por nuestro equipo. Recibirá una notificación cuando sea enviado.',
    pre_finalizing: 'Su pedido está siendo finalizado antes del envío. Su paquete estará en camino en un momento.',
    pre_restock: 'Este modelo tiene un gran éxito y nuestro equipo prepara su pedido con la mayor atención. La fecha estimada tiene en cuenta este plazo.',
    pre_priority: 'Su pedido recibe un tratamiento prioritario: nuestro equipo sigue personalmente su envío. ¿Una pregunta? Nuestro servicio al cliente le responde con prioridad.',
    order_placed_on: 'Realizado el',
    estimated_delivery: 'Entrega estimada',
    progress_order: 'Pedido',
    progress_delivery: 'Entrega',
    tracking_number_title: 'Su número de seguimiento',
    tracking_btn: 'Seguir mi paquete en tiempo real →',
    last_update: 'Última actualización de la red:',
    last_update_less_1h: 'hace menos de una hora',
    last_update_hours: 'hace {n}h',
    last_update_date: 'el',
    estimate_reminder: 'Entrega estimada: {date}',
    contact_question: '¿Una pregunta sobre su entrega?',
    contact_link: 'Contacte con nuestro servicio al cliente',
    new_search: '← Seguir otro pedido',
    magic_banner: 'Acceso seguro — está conectado a través de su enlace personal.',
    error_invalid: 'Por favor, verifique sus datos.',
    error_token: 'Enlace de seguimiento inválido o caducado.',
    error_network: 'No se puede contactar con el servicio de seguimiento. Inténtelo de nuevo.',
    cancel_intro: '¿Tarda demasiado?',
    cancel_btn: 'Cancelar mi pedido',
    cancel_checking: 'Verificando…',
    cancel_checking_text: 'Estamos verificando si su pedido aún puede ser cancelado.',
    cancel_title_priority: 'Cancelación de su pedido',
    cancel_text_priority: 'Su pedido tiene un retraso que lamentamos. Está en tratamiento prioritario y será enviado lo antes posible. Puede cancelarlo y recibir un reembolso completo.',
    cancel_title_restock: 'Cancelación de su pedido',
    cancel_text_restock: 'Su pedido está siendo finalizado antes del envío. Puede cancelarlo y recibir un reembolso completo en cualquier momento antes del envío.',
    cancel_keep: 'Mantener mi pedido',
    cancel_confirm: 'Cancelar y obtener reembolso',
    cancel_impossible: 'Cancelación no posible',
    cancel_already_shipped: 'Su pedido ya está en proceso de envío. La cancelación automática ya no es posible.',
    cancel_not_found: 'No pudimos encontrar su pedido en nuestro sistema.',
    cancel_error_generic: 'Un error técnico nos impide procesar su solicitud en este momento.',
    cancel_team_available: 'Nuestro equipo está disponible para ayudarle.',
    cancel_contact: 'Contactar soporte',
    cancel_close: 'Cerrar',
    cancel_processing: 'Cancelando…',
    cancel_processing_text: 'Estamos procesando su solicitud, por favor espere.',
    cancel_success: 'Pedido cancelado',
    cancel_success_text: 'Su pedido {order} ha sido cancelado con éxito. Se le reembolsarán {amount} {currency} en un plazo de 5 a 10 días hábiles.',
    cancel_failed: 'Cancelación fallida',
    cancel_failed_text: 'Se produjo un error durante la cancelación. Nuestro equipo ha sido notificado y se pondrá en contacto con usted.',
    cancel_error_connection: 'Error de conexión',
    cancel_error_connection_text: 'No se puede contactar con nuestro servicio. Inténtelo de nuevo o contacte con soporte.',
    cancel_error_finalize: 'No se pudo completar la cancelación. Contacte con nuestro soporte.',
    page_title: 'Seguimiento de tu pedido',
    page_subtitle: 'Consulta en tiempo real el estado de envío de tu pulsera.',
    form_title: 'Acceder a mi seguimiento',
    label_email: 'Dirección de email',
    label_order: 'Número de pedido',
    placeholder_email: 'tu@email.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Seguir mi pedido',
    loader_title: 'Estamos recuperando las últimas actualizaciones de tu envío…',
    loader_sub: 'Esto tarda unos segundos',
    loader_step2_msg: 'Verificando tu pedido…',
    loader_step3_msg: 'Analizando datos de seguimiento…',
    result_badge_default: 'En preparación',
    result_est_label: 'Entrega estimada',
    result_your_order: 'SU PEDIDO',
    info_tip_delay: 'Los plazos pueden variar según el transportista.',
    result_progress_order: 'Pedido',
    result_progress_delivery: 'Entrega',
    result_tn_title: 'Tu número de seguimiento',
    result_tn_btn: 'Seguir mi paquete en tiempo real →',
    result_timeline_title: 'Progreso de tu pedido',
    result_help: '¿Una pregunta sobre tu envío?',
    result_help_link: 'Contacta con nuestro servicio al cliente',
    result_new_search: '← Seguir otro pedido',
    delay_transit_late: 'Vuestras pulseras favoritas han tenido un éxito increíble y hemos tenido que reabastecernos antes de enviarlas. ¡Vuestro paquete ya está en camino! Muchas gracias por vuestra paciencia y confianza.',
    delivered_on: 'Entregado el {date}',
    cs_same_info: 'Estás viendo la misma información sobre el estado del pedido a la que nuestros agentes de atención al cliente pueden acceder.',
    at_latest: 'a m\u00e1s tardar el',
    countdown_days: 'Aproximadamente {n} d\u00edas restantes.',
    countdown_day: 'Entrega prevista ma\u00f1ana.',
    countdown_today: 'Entrega prevista hoy.',
    next_step_label: 'Pr\u00f3ximo paso:',
    next_step_5: 'En camino hacia tu zona.',
    next_step_6: 'Llegada al centro de clasificaci\u00f3n.',
    next_step_7: 'Entrega a tu transportista local.',
    next_step_8: 'Recogido por tu transportista.',
    next_step_9: 'Entrega en tu direcci\u00f3n.',
    next_step_10: 'Tu repartidor recoge tu paquete.',
    next_step_11: 'Entrega en tu direcci\u00f3n.',
    faq_title: 'Preguntas frecuentes',
    faq_q1: '\u00bfPor qu\u00e9 mi seguimiento no se actualiza?',
    faq_a1: 'Los transportistas no escanean los paquetes en cada etapa. Es normal que no aparezca ninguna actualizaci\u00f3n durante 2 a 5 d\u00edas.',
    faq_q2: '\u00bfPuede llegar mi pedido antes?',
    faq_a2: '\u00a1S\u00ed, es posible! Siempre hacemos lo m\u00e1ximo para entregar lo antes posible.',
    faq_q3: '\u00bfQu\u00e9 pasa si no estoy disponible?',
    faq_a3: 'El transportista dejar\u00e1 un aviso o tu paquete ser\u00e1 depositado en un punto de recogida.',
    faq_q4: '¿Puedo cancelar mi pedido?',
    faq_a4: 'Una vez que tu pedido ha sido enviado, ya no es posible cancelarlo. Podrás realizar una devolución gratuita tras la recepción.',
    sav_help: '\u00bfNecesitas ayuda? Nuestro equipo responde en 24 horas (d\u00edas laborables).',
    patience_scan_imminent: 'Actualización inminente — tu paquete avanza con normalidad.',
    patience_scan_hours: 'Próxima actualización esperada en las próximas horas.',
    patience_scan_day: 'Próxima actualización esperada para el {day} por la noche.',
    patience_benchmark: 'Los pedidos llegan en un promedio de {avg} días. El tuyo lleva {days} días en camino.',
    patience_reassurance: 'El {pct}% de los pedidos llegan dentro del plazo estimado.',
    patience_scan_overdue: 'El escaneo esperado a\u00fan no ha llegado \u2014 esto afecta al {pct}% de los paquetes en esta etapa, sin impacto en la fecha de entrega estimada.',
    patience_reason_flight: 'los paquetes no se escanean entre centros de clasificaci\u00f3n.',
    patience_reason_hub: 'el procesamiento en el centro de clasificaci\u00f3n puede tardar unas horas.',
    patience_reason_local: 'tu transportista local est\u00e1 realizando los escaneos de distribuci\u00f3n.'
  },
  /* ─── GREC ─── */
  el: {
    locale_date: 'el-GR',
    step_1_title: 'Παραγγελία επιβεβαιωμένη',
    step_1_desc: 'Ευχαριστούμε για την εμπιστοσύνη σας! Η πληρωμή σας επιβεβαιώθηκε και η παραγγελία σας καταχωρήθηκε.',
    step_2_title: 'Σε προετοιμασία',
    step_2_desc: 'Η παραγγελία σας προετοιμάζεται από την ομάδα μας. Θα αποσταλεί πολύ σύντομα.',
    step_3_title: 'Δέμα απεστάλη',
    step_3_desc: 'Η παραγγελία σας έχει αποσταλεί! Μπορείτε τώρα να παρακολουθείτε την πορεία της βήμα βήμα.',
    step_4_title: 'Δέμα παραλήφθηκε',
    step_4_desc: 'Το δέμα σας παραδόθηκε στον μεταφορέα μας και η παρακολούθηση είναι πλέον ενεργή.',
    step_5_title: 'Καθ\' οδόν προς εσάς',
    step_5_desc: 'Το δέμα σας είναι καθ\' οδόν. Κάθε βήμα το φέρνει πιο κοντά σας.',
    step_6_title: 'Σε μεταφορά',
    step_6_desc: 'Το δέμα σας προχωρά βήμα βήμα. Μερικές ημέρες μπορεί να περάσουν μεταξύ ενημερώσεων — είναι απολύτως φυσιολογικό.',
    step_7_title: 'Έφτασε στην περιοχή σας',
    step_7_desc: 'Καλά νέα: το δέμα σας έφτασε στην περιοχή σας. Βρίσκεται στην τελευταία φάση πριν την παράδοση.',
    step_8_title: 'Τελικός έλεγχος',
    step_8_desc: 'Πραγματοποιούμε έναν τελικό έλεγχο για να διασφαλίσουμε ότι το δέμα σας θα φτάσει στην καλύτερη κατάσταση. Λίγα ακόμα βήματα!',
    step_9_title: 'Προς την πόλη σας',
    step_9_desc: 'Το δέμα σας πλησιάζει στη διεύθυνσή σας. Η παράδοση πλησιάζει.',
    step_10_title: 'Σχεδόν εκεί',
    step_10_desc: 'Το δέμα σας έφτασε στην περιοχή παράδοσής σας. Ο διανομέας θα το παραλάβει πολύ σύντομα — σχεδόν τελειώσαμε!',
    step_11_title: 'Σε παράδοση',
    step_11_desc: 'Σήμερα είναι η μέρα: ο διανομέας σας είναι σε δρομολόγιο με το δέμα σας. Μείνετε κοντά, η παραγγελία σας φτάνει σήμερα!',
    step_12_title: 'Η παραγγελία σας έφτασε',
    step_12_desc: 'Η παραγγελία σας παραδόθηκε! Ελπίζουμε να σας αρέσει το βραχιόλι σας. Ερωτήσεις; Η ομάδα μας είναι εδώ για εσάς.',
    badge_transit: 'Καθ\' οδόν',
    badge_delivered: 'Παραδόθηκε',
    badge_preparing: 'Σε προετοιμασία',
    badge_priority: 'Ανεφοδιασμός',
    badge_shipped: 'Απεστάλη',
    badge_pickup: 'Σε παράδοση',
    badge_undelivered: 'Επαναπρογραμματισμός παράδοσης',
    badge_exception: 'Υπό εξέταση',
    badge_late: 'Καθυστερημένο',
    badge_default: 'Σε εξέλιξη',
    pre_preparing: 'Η παραγγελία σας ελήφθη και προετοιμάζεται από την ομάδα μας. Θα λάβετε ειδοποίηση μόλις αποσταλεί.',
    pre_finalizing: 'Η παραγγελία σας ολοκληρώνεται πριν την αποστολή. Το δέμα σας θα είναι σύντομα καθ\' οδόν.',
    pre_restock: 'Αυτό το μοντέλο είναι εξαιρετικά δημοφιλές και η ομάδα μας προετοιμάζει την παραγγελία σας με τη μεγαλύτερη φροντίδα. Η εκτιμώμενη ημερομηνία λαμβάνει υπόψη αυτή την καθυστέρηση.',
    pre_priority: 'Η παραγγελία σας λαμβάνει προτεραιότητα: η ομάδα μας παρακολουθεί προσωπικά την αποστολή της. Ερωτήσεις; Η εξυπηρέτηση πελατών μας θα σας απαντήσει κατά προτεραιότητα.',
    order_placed_on: 'Τοποθετήθηκε στις',
    estimated_delivery: 'Εκτιμώμενη παράδοση',
    progress_order: 'Παραγγελία',
    progress_delivery: 'Παράδοση',
    tracking_number_title: 'Ο αριθμός παρακολούθησής σας',
    tracking_btn: 'Παρακολούθηση σε πραγματικό χρόνο →',
    last_update: 'Τελευταία ενημέρωση δικτύου:',
    last_update_less_1h: 'πριν από λιγότερο από μία ώρα',
    last_update_hours: 'πριν από {n} ώρες',
    last_update_date: 'στις',
    estimate_reminder: 'Εκτιμώμενη παράδοση: {date}',
    contact_question: 'Ερώτηση σχετικά με την παράδοσή σας;',
    contact_link: 'Επικοινωνήστε με την εξυπηρέτηση πελατών',
    new_search: '← Παρακολούθηση άλλης παραγγελίας',
    magic_banner: 'Ασφαλής πρόσβαση — είστε συνδεδεμένοι μέσω του προσωπικού σας συνδέσμου.',
    error_invalid: 'Παρακαλώ ελέγξτε τα στοιχεία σας.',
    error_token: 'Μη έγκυρος ή ληγμένος σύνδεσμος παρακολούθησης.',
    error_network: 'Αδυναμία σύνδεσης με την υπηρεσία παρακολούθησης. Δοκιμάστε ξανά.',
    cancel_intro: 'Καθυστερεί πολύ;',
    cancel_btn: 'Ακύρωση παραγγελίας',
    cancel_checking: 'Έλεγχος…',
    cancel_checking_text: 'Ελέγχουμε αν η παραγγελία σας μπορεί ακόμα να ακυρωθεί.',
    cancel_title_priority: 'Ακύρωση παραγγελίας',
    cancel_text_priority: 'Η παραγγελία σας έχει καθυστέρηση που λυπούμαστε. Λαμβάνει προτεραιότητα και θα αποσταλεί το συντομότερο δυνατό. Μπορείτε να την ακυρώσετε και να λάβετε πλήρη επιστροφή χρημάτων.',
    cancel_title_restock: 'Ακύρωση παραγγελίας',
    cancel_text_restock: 'Η παραγγελία σας ολοκληρώνεται πριν την αποστολή. Μπορείτε να την ακυρώσετε και να λάβετε πλήρη επιστροφή χρημάτων ανά πάσα στιγμή πριν την αποστολή.',
    cancel_keep: 'Διατήρηση παραγγελίας',
    cancel_confirm: 'Ακύρωση και επιστροφή χρημάτων',
    cancel_impossible: 'Ακύρωση αδύνατη',
    cancel_already_shipped: 'Η παραγγελία σας βρίσκεται ήδη σε αποστολή. Η αυτόματη ακύρωση δεν είναι πλέον δυνατή.',
    cancel_not_found: 'Δεν βρήκαμε την παραγγελία σας στο σύστημά μας.',
    cancel_error_generic: 'Ένα τεχνικό σφάλμα μας εμποδίζει να επεξεργαστούμε το αίτημά σας.',
    cancel_team_available: 'Η ομάδα μας είναι διαθέσιμη για να σας βοηθήσει.',
    cancel_contact: 'Επικοινωνία με υποστήριξη',
    cancel_close: 'Κλείσιμο',
    cancel_processing: 'Ακύρωση σε εξέλιξη…',
    cancel_processing_text: 'Επεξεργαζόμαστε το αίτημά σας, παρακαλώ περιμένετε.',
    cancel_success: 'Παραγγελία ακυρώθηκε',
    cancel_success_text: 'Η παραγγελία σας {order} ακυρώθηκε επιτυχώς. Θα επιστραφούν {amount} {currency} εντός 5 έως 10 εργάσιμων ημερών.',
    cancel_failed: 'Αποτυχία ακύρωσης',
    cancel_failed_text: 'Παρουσιάστηκε σφάλμα κατά την ακύρωση. Η ομάδα μας ενημερώθηκε και θα επικοινωνήσει μαζί σας.',
    cancel_error_connection: 'Σφάλμα σύνδεσης',
    cancel_error_connection_text: 'Αδυναμία σύνδεσης με την υπηρεσία μας. Δοκιμάστε ξανά ή επικοινωνήστε με την υποστήριξη.',
    cancel_error_finalize: 'Αδυναμία ολοκλήρωσης ακύρωσης. Επικοινωνήστε με την υποστήριξή μας.',
    page_title: 'Παρακολούθηση παραγγελίας',
    page_subtitle: 'Παρακολουθήστε σε πραγματικό χρόνο την κατάσταση αποστολής του βραχιολιού σας.',
    form_title: 'Πρόσβαση στην παρακολούθηση',
    label_email: 'Διεύθυνση email',
    label_order: 'Αριθμός παραγγελίας',
    placeholder_email: 'email@σας.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Παρακολούθηση παραγγελίας',
    loader_title: 'Ανακτούμε τις τελευταίες ενημερώσεις της αποστολής σας…',
    loader_sub: 'Αυτό διαρκεί λίγα δευτερόλεπτα',
    loader_step2_msg: 'Επαλήθευση της παραγγελίας σας…',
    loader_step3_msg: 'Ανάλυση δεδομένων παρακολούθησης…',
    result_badge_default: 'Σε προετοιμασία',
    result_est_label: 'Εκτιμώμενη παράδοση',
    result_your_order: 'Η ΠΑΡΑΓΓΕΛΙΑ ΣΑΣ',
    info_tip_delay: 'Οι χρόνοι παράδοσης μπορεί να διαφέρουν ανάλογα με τον μεταφορέα.',
    result_progress_order: 'Παραγγελία',
    result_progress_delivery: 'Παράδοση',
    result_tn_title: 'Ο αριθμός παρακολούθησής σας',
    result_tn_btn: 'Παρακολουθήστε το δέμα σε πραγματικό χρόνο →',
    result_timeline_title: 'Πρόοδος παραγγελίας',
    result_help: 'Ερώτηση σχετικά με την αποστολή;',
    result_help_link: 'Επικοινωνήστε με την εξυπηρέτηση πελατών',
    result_new_search: '← Παρακολούθηση άλλης παραγγελίας',
    delay_transit_late: 'Τα αγαπημένα σας βραχιόλια είχαν τεράστια επιτυχία και χρειάστηκε να ανανεώσουμε το απόθεμά μας πριν σας τα στείλουμε. Το δέμα σας είναι τώρα καθ\' οδόν! Σας ευχαριστούμε πολύ για την υπομονή και την εμπιστοσύνη σας.',
    delivered_on: 'Παραδόθηκε στις {date}',
    cs_same_info: 'Βλέπετε τις ίδιες πληροφορίες κατάστασης παραγγελίας που μπορούν να δουν και οι πράκτορες εξυπηρέτησης πελατών μας.',
    at_latest: '\u03c4\u03bf \u03b1\u03c1\u03b3\u03cc\u03c4\u03b5\u03c1\u03bf \u03c3\u03c4\u03b9\u03c2',
    countdown_days: '\u0391\u03c0\u03bf\u03bc\u03ad\u03bd\u03bf\u03c5\u03bd \u03c0\u03b5\u03c1\u03af\u03c0\u03bf\u03c5 {n} \u03b7\u03bc\u03ad\u03c1\u03b5\u03c2.',
    countdown_day: '\u0397 \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7 \u03b1\u03bd\u03b1\u03bc\u03ad\u03bd\u03b5\u03c4\u03b1\u03b9 \u03b1\u03cd\u03c1\u03b9\u03bf.',
    countdown_today: '\u0397 \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7 \u03b1\u03bd\u03b1\u03bc\u03ad\u03bd\u03b5\u03c4\u03b1\u03b9 \u03c3\u03ae\u03bc\u03b5\u03c1\u03b1.',
    next_step_label: '\u0395\u03c0\u03cc\u03bc\u03b5\u03bd\u03bf \u03b2\u03ae\u03bc\u03b1:',
    next_step_5: '\u039c\u03b5\u03c4\u03b1\u03c6\u03bf\u03c1\u03ac \u03c0\u03c1\u03bf\u03c2 \u03c4\u03b7\u03bd \u03c0\u03b5\u03c1\u03b9\u03bf\u03c7\u03ae \u03c3\u03b1\u03c2.',
    next_step_6: '\u0386\u03c6\u03b9\u03be\u03b7 \u03c3\u03c4\u03bf \u03ba\u03ad\u03bd\u03c4\u03c1\u03bf \u03b4\u03b9\u03b1\u03bb\u03bf\u03b3\u03ae\u03c2.',
    next_step_7: '\u03a0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7 \u03c3\u03c4\u03bf\u03bd \u03c4\u03bf\u03c0\u03b9\u03ba\u03cc \u03bc\u03b5\u03c4\u03b1\u03c6\u03bf\u03c1\u03ad\u03b1.',
    next_step_8: '\u03a0\u03b1\u03c1\u03b1\u03bb\u03b1\u03b2\u03ae \u03b1\u03c0\u03cc \u03c4\u03bf\u03bd \u03bc\u03b5\u03c4\u03b1\u03c6\u03bf\u03c1\u03ad\u03b1.',
    next_step_9: '\u03a0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7 \u03c3\u03c4\u03b7 \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03ae \u03c3\u03b1\u03c2.',
    next_step_10: '\u039f \u03b4\u03b9\u03b1\u03bd\u03bf\u03bc\u03ad\u03b1\u03c2 \u03c0\u03b1\u03c1\u03b1\u03bb\u03b1\u03bc\u03b2\u03ac\u03bd\u03b5\u03b9 \u03c4\u03bf \u03b4\u03ad\u03bc\u03b1 \u03c3\u03b1\u03c2.',
    next_step_11: '\u03a0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7 \u03c3\u03c4\u03b7 \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03ae \u03c3\u03b1\u03c2.',
    faq_title: '\u03a3\u03c5\u03c7\u03bd\u03ad\u03c2 \u03b5\u03c1\u03c9\u03c4\u03ae\u03c3\u03b5\u03b9\u03c2',
    faq_q1: '\u0393\u03b9\u03b1\u03c4\u03af \u03b4\u03b5\u03bd \u03b5\u03bd\u03b7\u03bc\u03b5\u03c1\u03ce\u03bd\u03b5\u03c4\u03b1\u03b9 \u03b7 \u03c0\u03b1\u03c1\u03b1\u03ba\u03bf\u03bb\u03bf\u03cd\u03b8\u03b7\u03c3\u03ae \u03bc\u03bf\u03c5;',
    faq_a1: '\u039f\u03b9 \u03bc\u03b5\u03c4\u03b1\u03c6\u03bf\u03c1\u03b5\u03af\u03c2 \u03b4\u03b5\u03bd \u03c3\u03b1\u03c1\u03ce\u03bd\u03bf\u03c5\u03bd \u03c4\u03b1 \u03b4\u03ad\u03bc\u03b1\u03c4\u03b1 \u03c3\u03b5 \u03ba\u03ac\u03b8\u03b5 \u03b2\u03ae\u03bc\u03b1. \u0395\u03af\u03bd\u03b1\u03b9 \u03c6\u03c5\u03c3\u03b9\u03bf\u03bb\u03bf\u03b3\u03b9\u03ba\u03cc \u03bd\u03b1 \u03bc\u03b7\u03bd \u03b5\u03bc\u03c6\u03b1\u03bd\u03af\u03b6\u03b5\u03c4\u03b1\u03b9 \u03b5\u03bd\u03b7\u03bc\u03ad\u03c1\u03c9\u03c3\u03b7 \u03b3\u03b9\u03b1 2 \u03ad\u03c9\u03c2 5 \u03b7\u03bc\u03ad\u03c1\u03b5\u03c2.',
    faq_q2: '\u039c\u03c0\u03bf\u03c1\u03b5\u03af \u03bd\u03b1 \u03c6\u03c4\u03ac\u03c3\u03b5\u03b9 \u03bd\u03c9\u03c1\u03af\u03c4\u03b5\u03c1\u03b1;',
    faq_a2: '\u039d\u03b1\u03b9, \u03b5\u03af\u03bd\u03b1\u03b9 \u03c0\u03b9\u03b8\u03b1\u03bd\u03cc! \u039a\u03ac\u03bd\u03bf\u03c5\u03bc\u03b5 \u03c0\u03ac\u03bd\u03c4\u03b1 \u03c4\u03bf \u03ba\u03b1\u03bb\u03cd\u03c4\u03b5\u03c1\u03bf \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03c0\u03b1\u03c1\u03b1\u03b4\u03ce\u03c3\u03bf\u03c5\u03bc\u03b5 \u03cc\u03c3\u03bf \u03c0\u03b9\u03bf \u03b3\u03c1\u03ae\u03b3\u03bf\u03c1\u03b1.',
    faq_q3: '\u03a4\u03b9 \u03b3\u03af\u03bd\u03b5\u03c4\u03b1\u03b9 \u03b1\u03bd \u03b4\u03b5\u03bd \u03b5\u03af\u03bc\u03b1\u03b9 \u03b4\u03b9\u03b1\u03b8\u03ad\u03c3\u03b9\u03bc\u03bf\u03c2;',
    faq_a3: '\u039f \u03bc\u03b5\u03c4\u03b1\u03c6\u03bf\u03c1\u03ad\u03b1\u03c2 \u03b8\u03b1 \u03b1\u03c6\u03ae\u03c3\u03b5\u03b9 \u03b5\u03b9\u03b4\u03bf\u03c0\u03bf\u03af\u03b7\u03c3\u03b7 \u03ae \u03c4\u03bf \u03b4\u03ad\u03bc\u03b1 \u03b8\u03b1 \u03c0\u03b1\u03c1\u03b1\u03b4\u03bf\u03b8\u03b5\u03af \u03c3\u03b5 \u03c3\u03b7\u03bc\u03b5\u03af\u03bf \u03c0\u03b1\u03c1\u03b1\u03bb\u03b1\u03b2\u03ae\u03c2.',
    faq_q4: 'Μπορώ να ακυρώσω την παραγγελία μου;',
    faq_a4: 'Μόλις η παραγγελία σας αποσταλεί, δεν είναι πλέον δυνατή η ακύρωση. Μπορείτε να κάνετε δωρεάν επιστροφή μετά την παραλαβή.',
    sav_help: '\u03a7\u03c1\u03b5\u03b9\u03ac\u03b6\u03b5\u03c3\u03c4\u03b5 \u03b2\u03bf\u03ae\u03b8\u03b5\u03b9\u03b1; \u0397 \u03bf\u03bc\u03ac\u03b4\u03b1 \u03bc\u03b1\u03c2 \u03b1\u03c0\u03b1\u03bd\u03c4\u03ac \u03b5\u03bd\u03c4\u03cc\u03c2 24 \u03c9\u03c1\u03ce\u03bd (\u03b5\u03c1\u03b3\u03ac\u03c3\u03b9\u03bc\u03b5\u03c2).',
    patience_scan_imminent: 'Ενημέρωση σύντομα — το δέμα σας προχωρά κανονικά.',
    patience_scan_hours: 'Επόμενη ενημέρωση αναμένεται τις επόμενες ώρες.',
    patience_scan_day: 'Επόμενη ενημέρωση αναμένεται μέχρι {day} βράδυ.',
    patience_benchmark: 'Οι παραγγελίες φτάνουν κατά μέσο όρο σε {avg} ημέρες. Η δική σας είναι καθ\u2019 οδόν εδώ και {days} ημέρες.',
    patience_reassurance: 'Το {pct}% των παραγγελιών φτάνει εντός του εκτιμώμενου χρόνου.',
    patience_scan_overdue: '\u0397 \u03b1\u03bd\u03b1\u03bc\u03b5\u03bd\u03cc\u03bc\u03b5\u03bd\u03b7 \u03c3\u03ac\u03c1\u03c9\u03c3\u03b7 \u03b4\u03b5\u03bd \u03ad\u03c7\u03b5\u03b9 \u03c6\u03c4\u03ac\u03c3\u03b5\u03b9 \u03b1\u03ba\u03cc\u03bc\u03b1 \u2014 \u03b1\u03c5\u03c4\u03cc \u03b1\u03c6\u03bf\u03c1\u03ac \u03c4\u03bf {pct}% \u03c4\u03c9\u03bd \u03b4\u03b5\u03bc\u03ac\u03c4\u03c9\u03bd \u03c3\u03b5 \u03b1\u03c5\u03c4\u03cc \u03c4\u03bf \u03c3\u03c4\u03ac\u03b4\u03b9\u03bf, \u03c7\u03c9\u03c1\u03af\u03c2 \u03b5\u03c0\u03af\u03c0\u03c4\u03c9\u03c3\u03b7 \u03c3\u03c4\u03b7\u03bd \u03b5\u03ba\u03c4\u03b9\u03bc\u03ce\u03bc\u03b5\u03bd\u03b7 \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7\u03c2.',
    patience_reason_flight: '\u03c4\u03b1 \u03b4\u03ad\u03bc\u03b1\u03c4\u03b1 \u03b4\u03b5\u03bd \u03c3\u03b1\u03c1\u03ce\u03bd\u03bf\u03bd\u03c4\u03b1\u03b9 \u03bc\u03b5\u03c4\u03b1\u03be\u03cd \u03ba\u03ad\u03bd\u03c4\u03c1\u03c9\u03bd \u03b4\u03b9\u03b1\u03bb\u03bf\u03b3\u03ae\u03c2.',
    patience_reason_hub: '\u03b7 \u03b5\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1 \u03c3\u03c4\u03bf \u03ba\u03ad\u03bd\u03c4\u03c1\u03bf \u03b4\u03b9\u03b1\u03bb\u03bf\u03b3\u03ae\u03c2 \u03bc\u03c0\u03bf\u03c1\u03b5\u03af \u03bd\u03b1 \u03b4\u03b9\u03b1\u03c1\u03ba\u03ad\u03c3\u03b5\u03b9 \u03bc\u03b5\u03c1\u03b9\u03ba\u03ad\u03c2 \u03ce\u03c1\u03b5\u03c2.',
    patience_reason_local: '\u03bf \u03c4\u03bf\u03c0\u03b9\u03ba\u03cc\u03c2 \u03bc\u03b5\u03c4\u03b1\u03c6\u03bf\u03c1\u03ad\u03b1\u03c2 \u03c3\u03b1\u03c2 \u03c0\u03c1\u03b1\u03b3\u03bc\u03b1\u03c4\u03bf\u03c0\u03bf\u03b9\u03b5\u03af \u03c4\u03b9\u03c2 \u03c3\u03b1\u03c1\u03ce\u03c3\u03b5\u03b9\u03c2 \u03b4\u03b9\u03b1\u03bd\u03bf\u03bc\u03ae\u03c2.'
  },
  /* ─── ITALIEN ─── */
  it: {
    locale_date: 'it-IT',
    step_1_title: 'Ordine confermato',
    step_1_desc: 'Grazie per la fiducia! Il pagamento è stato confermato e il tuo ordine registrato.',
    step_2_title: 'In preparazione',
    step_2_desc: 'Il tuo ordine è in fase di preparazione dal nostro team. Sarà spedito molto presto.',
    step_3_title: 'Pacco spedito',
    step_3_desc: 'Il tuo ordine è stato spedito! Ora puoi seguire il suo percorso passo dopo passo.',
    step_4_title: 'Pacco preso in carico',
    step_4_desc: 'Il tuo pacco è stato affidato al nostro corriere e il tracciamento è ora attivo.',
    step_5_title: 'In viaggio verso di te',
    step_5_desc: 'Il tuo pacco è in viaggio. Ogni tappa lo avvicina a te.',
    step_6_title: 'In transito',
    step_6_desc: 'Il tuo pacco avanza tappa dopo tappa. Possono trascorrere alcuni giorni tra un aggiornamento e l\'altro — è perfettamente normale.',
    step_7_title: 'Arrivato nella tua zona',
    step_7_desc: 'Buone notizie: il tuo pacco è arrivato nella tua regione. È nell\'ultima fase prima della consegna.',
    step_8_title: 'Ultimo controllo',
    step_8_desc: 'Stiamo effettuando un ultimo controllo per assicurarci che il tuo pacco arrivi nelle migliori condizioni. Ancora pochi passaggi!',
    step_9_title: 'In arrivo nella tua città',
    step_9_desc: 'Il tuo pacco si avvicina al tuo indirizzo. La consegna è imminente.',
    step_10_title: 'Quasi arrivato',
    step_10_desc: 'Il tuo pacco è arrivato nella tua zona di consegna. Il corriere lo ritirerà molto presto — ci siamo quasi!',
    step_11_title: 'In consegna',
    step_11_desc: 'Oggi è il grande giorno: il tuo corriere è in giro con il tuo pacco. Resta nelle vicinanze, il tuo ordine arriva oggi!',
    step_12_title: 'Il tuo ordine è arrivato',
    step_12_desc: 'Il tuo ordine è stato consegnato! Speriamo che il tuo braccialetto ti piaccia. Domande? Il nostro team è a tua disposizione.',
    badge_transit: 'In viaggio',
    badge_delivered: 'Consegnato',
    badge_preparing: 'In preparazione',
    badge_priority: 'Rifornimento',
    badge_shipped: 'Spedito',
    badge_pickup: 'In consegna',
    badge_undelivered: 'Consegna da riprogrammare',
    badge_exception: 'In verifica',
    badge_late: 'In ritardo',
    badge_default: 'In corso',
    pre_preparing: 'Il tuo ordine è stato ricevuto ed è in fase di preparazione dal nostro team. Riceverai una notifica non appena verrà spedito.',
    pre_finalizing: 'Il tuo ordine è in fase di finalizzazione prima della spedizione. Il tuo pacco sarà in viaggio tra poco.',
    pre_restock: 'Questo modello ha un enorme successo e il nostro team prepara il tuo ordine con la massima cura. La data stimata tiene conto di questo ritardo.',
    pre_priority: 'Il tuo ordine riceve un trattamento prioritario: il nostro team segue personalmente la spedizione. Domande? Il nostro servizio clienti ti risponde con priorità.',
    order_placed_on: 'Effettuato il',
    estimated_delivery: 'Consegna stimata',
    progress_order: 'Ordine',
    progress_delivery: 'Consegna',
    tracking_number_title: 'Il tuo numero di tracciamento',
    tracking_btn: 'Segui il mio pacco in tempo reale →',
    last_update: 'Ultimo aggiornamento della rete:',
    last_update_less_1h: 'meno di un\'ora fa',
    last_update_hours: '{n} ore fa',
    last_update_date: 'il',
    estimate_reminder: 'Consegna stimata: {date}',
    contact_question: 'Una domanda sulla tua consegna?',
    contact_link: 'Contatta il nostro servizio clienti',
    new_search: '← Traccia un altro ordine',
    magic_banner: 'Accesso sicuro — sei connesso tramite il tuo link personale.',
    error_invalid: 'Verifica i tuoi dati.',
    error_token: 'Link di tracciamento non valido o scaduto.',
    error_network: 'Impossibile contattare il servizio di tracciamento. Riprova.',
    cancel_intro: 'Troppo tempo di attesa?',
    cancel_btn: 'Annulla il mio ordine',
    cancel_checking: 'Verifica in corso…',
    cancel_checking_text: 'Stiamo verificando se il tuo ordine può ancora essere annullato.',
    cancel_title_priority: 'Annullamento del tuo ordine',
    cancel_text_priority: 'Il tuo ordine ha subito un ritardo che ci dispiace. È in trattamento prioritario e verrà spedito il prima possibile. Puoi annullarlo e ricevere un rimborso completo.',
    cancel_title_restock: 'Annullamento del tuo ordine',
    cancel_text_restock: 'Il tuo ordine è in fase di finalizzazione prima della spedizione. Puoi annullarlo e ricevere un rimborso completo in qualsiasi momento prima della spedizione.',
    cancel_keep: 'Mantenere il mio ordine',
    cancel_confirm: 'Annulla e ottieni rimborso',
    cancel_impossible: 'Annullamento non possibile',
    cancel_already_shipped: 'Il tuo ordine è già in fase di spedizione. L\'annullamento automatico non è più possibile.',
    cancel_not_found: 'Non abbiamo trovato il tuo ordine nel nostro sistema.',
    cancel_error_generic: 'Un errore tecnico ci impedisce di elaborare la tua richiesta.',
    cancel_team_available: 'Il nostro team è disponibile per aiutarti.',
    cancel_contact: 'Contatta il supporto',
    cancel_close: 'Chiudi',
    cancel_processing: 'Annullamento in corso…',
    cancel_processing_text: 'Stiamo elaborando la tua richiesta, attendi.',
    cancel_success: 'Ordine annullato',
    cancel_success_text: 'Il tuo ordine {order} è stato annullato con successo. Riceverai un rimborso di {amount} {currency} entro 5-10 giorni lavorativi.',
    cancel_failed: 'Annullamento fallito',
    cancel_failed_text: 'Si è verificato un errore durante l\'annullamento. Il nostro team è stato avvisato e ti contatterà.',
    cancel_error_connection: 'Errore di connessione',
    cancel_error_connection_text: 'Impossibile contattare il nostro servizio. Riprova o contatta il supporto.',
    cancel_error_finalize: 'Impossibile completare l\'annullamento. Contatta il nostro supporto.',
    page_title: 'Tracciamento del tuo ordine',
    page_subtitle: 'Segui in tempo reale lo stato di spedizione del tuo braccialetto.',
    form_title: 'Accedi al mio tracciamento',
    label_email: 'Indirizzo email',
    label_order: 'Numero ordine',
    placeholder_email: 'tua@email.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Traccia il mio ordine',
    loader_title: 'Stiamo recuperando gli ultimi aggiornamenti sulla tua spedizione…',
    loader_sub: 'Ci vogliono pochi secondi',
    loader_step2_msg: 'Verifica del tuo ordine…',
    loader_step3_msg: 'Analisi dei dati di tracciamento…',
    result_badge_default: 'In preparazione',
    result_est_label: 'Consegna stimata',
    result_your_order: 'IL TUO ORDINE',
    info_tip_delay: 'I tempi di consegna possono variare in base al corriere.',
    result_progress_order: 'Ordine',
    result_progress_delivery: 'Consegna',
    result_tn_title: 'Il tuo numero di tracciamento',
    result_tn_btn: 'Segui il mio pacco in tempo reale →',
    result_timeline_title: 'Avanzamento del tuo ordine',
    result_help: 'Una domanda sulla tua consegna?',
    result_help_link: 'Contatta il nostro servizio clienti',
    result_new_search: '← Traccia un altro ordine',
    delay_transit_late: 'I vostri braccialetti preferiti hanno avuto un successo incredibile e abbiamo dovuto rifornirci prima di spedirli. Il vostro pacco è ora in viaggio! Grazie infinite per la vostra pazienza e fiducia.',
    delivered_on: 'Consegnato il {date}',
    cs_same_info: 'Stai visualizzando le stesse informazioni sullo stato dell\'ordine a cui possono accedere i nostri agenti del servizio clienti.',
    at_latest: 'al pi\u00f9 tardi il',
    countdown_days: 'Ancora circa {n} giorni.',
    countdown_day: 'Consegna prevista domani.',
    countdown_today: 'Consegna prevista oggi.',
    next_step_label: 'Prossimo passo:',
    next_step_5: 'In transito verso la tua zona.',
    next_step_6: 'Arrivo al centro di smistamento.',
    next_step_7: 'Consegna al corriere locale.',
    next_step_8: 'Preso in carico dal corriere.',
    next_step_9: 'Consegna al tuo indirizzo.',
    next_step_10: 'Il corriere sta ritirando il tuo pacco.',
    next_step_11: 'Consegna al tuo indirizzo.',
    faq_title: 'Domande frequenti',
    faq_q1: 'Perch\u00e9 il mio tracking non si aggiorna?',
    faq_a1: 'I corrieri non scansionano i pacchi ad ogni passaggio. \u00c8 normale che non appaiano aggiornamenti per 2-5 giorni.',
    faq_q2: 'Il mio ordine pu\u00f2 arrivare prima?',
    faq_a2: 'S\u00ec, \u00e8 possibile! Facciamo sempre del nostro meglio per consegnare il prima possibile.',
    faq_q3: 'Cosa succede se non sono disponibile?',
    faq_a3: 'Il corriere lascer\u00e0 un avviso o il pacco verr\u00e0 consegnato a un punto di ritiro.',
    faq_q4: 'Posso annullare il mio ordine?',
    faq_a4: 'Una volta che il tuo ordine è stato spedito, non è più possibile annullarlo. Potrai effettuare un reso gratuito dopo la ricezione.',
    sav_help: 'Hai bisogno di aiuto? Il nostro team risponde entro 24 ore (giorni lavorativi).',
    patience_scan_imminent: 'Aggiornamento imminente — il tuo pacco sta procedendo normalmente.',
    patience_scan_hours: 'Prossimo aggiornamento previsto nelle prossime ore.',
    patience_scan_day: 'Prossimo aggiornamento previsto entro {day} sera.',
    patience_benchmark: 'Gli ordini arrivano in media in {avg} giorni. Il tuo è in viaggio da {days} giorni.',
    patience_reassurance: 'Il {pct}% degli ordini arriva entro i tempi stimati.',
    patience_scan_overdue: 'La scansione prevista non \u00e8 ancora arrivata \u2014 questo riguarda il {pct}% dei pacchi in questa fase, senza impatto sulla data di consegna stimata.',
    patience_reason_flight: 'i pacchi non vengono scansionati tra i centri di smistamento.',
    patience_reason_hub: 'l\u2019elaborazione nel centro di smistamento pu\u00f2 richiedere qualche ora.',
    patience_reason_local: 'il tuo corriere locale sta effettuando le scansioni di distribuzione.'
  },
  /* ─── NÉERLANDAIS ─── */
  nl: {
    locale_date: 'nl-NL',
    step_1_title: 'Bestelling bevestigd',
    step_1_desc: 'Bedankt voor uw vertrouwen! Uw betaling is bevestigd en uw bestelling geregistreerd.',
    step_2_title: 'Wordt voorbereid',
    step_2_desc: 'Uw bestelling wordt voorbereid door ons team. Het wordt zeer binnenkort verzonden.',
    step_3_title: 'Pakket verzonden',
    step_3_desc: 'Uw bestelling is verzonden! U kunt nu stap voor stap de reis volgen.',
    step_4_title: 'Pakket opgehaald',
    step_4_desc: 'Uw pakket is overgedragen aan onze vervoerder en tracking is nu actief.',
    step_5_title: 'Onderweg naar u',
    step_5_desc: 'Uw pakket is onderweg. Elke stap brengt het dichter bij u.',
    step_6_title: 'In transit',
    step_6_desc: 'Uw pakket vordert stap voor stap. Er kunnen enkele dagen verstrijken tussen updates — dit is volkomen normaal.',
    step_7_title: 'Aangekomen in uw regio',
    step_7_desc: 'Goed nieuws: uw pakket is aangekomen in uw regio. Het bevindt zich in de laatste fase voor bezorging.',
    step_8_title: 'Laatste controle',
    step_8_desc: 'We voeren een laatste controle uit om ervoor te zorgen dat uw pakket in de beste staat aankomt. Nog maar een paar stappen!',
    step_9_title: 'Onderweg naar uw stad',
    step_9_desc: 'Uw pakket nadert uw adres. De bezorging komt snel dichterbij.',
    step_10_title: 'Bijna bij u',
    step_10_desc: 'Uw pakket is aangekomen in uw bezorggebied. Uw bezorger haalt het zeer binnenkort op — het is bijna klaar!',
    step_11_title: 'Wordt bezorgd',
    step_11_desc: 'Vandaag is de dag: uw bezorger is onderweg met uw pakket. Blijf in de buurt, uw bestelling komt vandaag aan!',
    step_12_title: 'Uw bestelling is aangekomen',
    step_12_desc: 'Uw bestelling is bezorgd! We hopen dat u geniet van uw armband. Vragen? Ons team staat voor u klaar.',
    badge_transit: 'Onderweg',
    badge_delivered: 'Bezorgd',
    badge_preparing: 'Wordt voorbereid',
    badge_priority: 'Herbevoorrading',
    badge_shipped: 'Verzonden',
    badge_pickup: 'Wordt bezorgd',
    badge_undelivered: 'Bezorging opnieuw plannen',
    badge_exception: 'Wordt gecontroleerd',
    badge_late: 'Vertraagd',
    badge_default: 'In behandeling',
    pre_preparing: 'Uw bestelling is ontvangen en wordt voorbereid door ons team. U ontvangt een melding zodra het wordt verzonden.',
    pre_finalizing: 'Uw bestelling wordt afgerond voor verzending. Uw pakket is zo onderweg.',
    pre_restock: 'Dit model is enorm populair en ons team bereidt uw bestelling met de grootste zorg voor. De geschatte datum houdt rekening met deze vertraging.',
    pre_priority: 'Uw bestelling krijgt een voorrangsbehandeling: ons team volgt de verzending persoonlijk. Vragen? Onze klantenservice antwoordt u met voorrang.',
    order_placed_on: 'Geplaatst op',
    estimated_delivery: 'Geschatte levering',
    progress_order: 'Bestelling',
    progress_delivery: 'Levering',
    tracking_number_title: 'Uw trackingnummer',
    tracking_btn: 'Volg mijn pakket in realtime →',
    last_update: 'Laatste netwerkupdate:',
    last_update_less_1h: 'minder dan een uur geleden',
    last_update_hours: '{n} uur geleden',
    last_update_date: 'op',
    estimate_reminder: 'Verwachte levering: {date}',
    contact_question: 'Een vraag over uw bezorging?',
    contact_link: 'Neem contact op met onze klantenservice',
    new_search: '← Volg een andere bestelling',
    magic_banner: 'Beveiligde toegang — u bent verbonden via uw persoonlijke link.',
    error_invalid: 'Controleer uw gegevens.',
    error_token: 'Ongeldige of verlopen trackinglink.',
    error_network: 'Kan de trackingservice niet bereiken. Probeer het opnieuw.',
    cancel_intro: 'Duurt het te lang?',
    cancel_btn: 'Bestelling annuleren',
    cancel_checking: 'Controleren…',
    cancel_checking_text: 'We controleren of uw bestelling nog geannuleerd kan worden.',
    cancel_title_priority: 'Annulering van uw bestelling',
    cancel_text_priority: 'Uw bestelling heeft een vertraging die we betreuren. Het wordt met voorrang behandeld en zo snel mogelijk verzonden. U kunt het annuleren en een volledige terugbetaling ontvangen.',
    cancel_title_restock: 'Annulering van uw bestelling',
    cancel_text_restock: 'Uw bestelling wordt afgerond voor verzending. U kunt het op elk moment voor verzending annuleren en een volledige terugbetaling ontvangen.',
    cancel_keep: 'Bestelling behouden',
    cancel_confirm: 'Annuleren en terugbetaling',
    cancel_impossible: 'Annulering niet mogelijk',
    cancel_already_shipped: 'Uw bestelling wordt al verzonden. Automatische annulering is niet meer mogelijk.',
    cancel_not_found: 'We konden uw bestelling niet vinden in ons systeem.',
    cancel_error_generic: 'Een technische fout verhindert ons uw verzoek te verwerken.',
    cancel_team_available: 'Ons team staat klaar om u te helpen.',
    cancel_contact: 'Contact opnemen met support',
    cancel_close: 'Sluiten',
    cancel_processing: 'Annulering bezig…',
    cancel_processing_text: 'We verwerken uw verzoek, even geduld.',
    cancel_success: 'Bestelling geannuleerd',
    cancel_success_text: 'Uw bestelling {order} is succesvol geannuleerd. U wordt terugbetaald {amount} {currency} binnen 5 tot 10 werkdagen.',
    cancel_failed: 'Annulering mislukt',
    cancel_failed_text: 'Er is een fout opgetreden bij de annulering. Ons team is op de hoogte gebracht en neemt contact met u op.',
    cancel_error_connection: 'Verbindingsfout',
    cancel_error_connection_text: 'Kan onze service niet bereiken. Probeer opnieuw of neem contact op met support.',
    cancel_error_finalize: 'Kan de annulering niet voltooien. Neem contact op met onze support.',
    page_title: 'Volg je bestelling',
    page_subtitle: 'Volg in realtime de verzendstatus van je armband.',
    form_title: 'Toegang tot mijn tracking',
    label_email: 'E-mailadres',
    label_order: 'Bestelnummer',
    placeholder_email: 'jouw@email.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Bestelling volgen',
    loader_title: 'We halen de laatste updates van je levering op…',
    loader_sub: 'Dit duurt een paar seconden',
    loader_step2_msg: 'Verificatie van je bestelling…',
    loader_step3_msg: 'Analyse van trackinggegevens…',
    result_badge_default: 'In voorbereiding',
    result_est_label: 'Geschatte levering',
    result_your_order: 'UW BESTELLING',
    info_tip_delay: 'Levertijden kunnen variëren afhankelijk van de vervoerder.',
    result_progress_order: 'Bestelling',
    result_progress_delivery: 'Levering',
    result_tn_title: 'Je trackingnummer',
    result_tn_btn: 'Volg mijn pakket in realtime →',
    result_timeline_title: 'Voortgang van je bestelling',
    result_help: 'Een vraag over je levering?',
    result_help_link: 'Neem contact op met onze klantenservice',
    result_new_search: '← Volg een andere bestelling',
    delay_transit_late: 'Jullie favoriete armbanden waren ongelooflijk populair en we moesten onze voorraad aanvullen voordat we ze konden verzenden. Je pakket is nu onderweg! Heel erg bedankt voor je geduld en vertrouwen.',
    delivered_on: 'Bezorgd op {date}',
    cs_same_info: 'Je ziet dezelfde bestelstatusinformatie als waar onze klantenservicemedewerkers toegang toe hebben.',
    at_latest: 'uiterlijk op',
    countdown_days: 'Nog ongeveer {n} dagen.',
    countdown_day: 'Levering verwacht morgen.',
    countdown_today: 'Levering verwacht vandaag.',
    next_step_label: 'Volgende stap:',
    next_step_5: 'Onderweg naar jouw regio.',
    next_step_6: 'Aankomst bij het sorteercentrum.',
    next_step_7: 'Overdracht aan je lokale bezorger.',
    next_step_8: 'Opgehaald door je bezorger.',
    next_step_9: 'Bezorging op je adres.',
    next_step_10: 'Je bezorger haalt je pakket op.',
    next_step_11: 'Bezorging op je adres.',
    faq_title: 'Veelgestelde vragen',
    faq_q1: 'Waarom wordt mijn tracking niet bijgewerkt?',
    faq_a1: 'Vervoerders scannen pakketten niet bij elke stap. Het is normaal dat er 2 tot 5 dagen geen update verschijnt.',
    faq_q2: 'Kan mijn bestelling eerder aankomen?',
    faq_a2: 'Ja, dat is mogelijk! We doen altijd ons best om zo snel mogelijk te leveren.',
    faq_q3: 'Wat als ik niet thuis ben?',
    faq_a3: 'De bezorger laat een bericht achter of je pakket wordt bij een afhaalpunt bezorgd.',
    faq_q4: 'Kan ik mijn bestelling annuleren?',
    faq_a4: 'Zodra je bestelling is verzonden, kan deze niet meer worden geannuleerd. Je kunt na ontvangst een gratis retour doen.',
    sav_help: 'Hulp nodig? Ons team reageert binnen 24 uur (werkdagen).',
    patience_scan_imminent: 'Update komt eraan — je pakket is onderweg.',
    patience_scan_hours: 'Volgende update verwacht binnen enkele uren.',
    patience_scan_day: 'Volgende update verwacht vóór {day} avond.',
    patience_benchmark: 'Bestellingen komen gemiddeld aan in {avg} dagen. De jouwe is al {days} dagen onderweg.',
    patience_reassurance: '{pct}% van de bestellingen komt binnen de geschatte levertijd aan.',
    patience_scan_overdue: 'De verwachte scan is nog niet binnengekomen \u2014 dit betreft {pct}% van de pakketten in deze fase, zonder invloed op de geschatte leverdatum.',
    patience_reason_flight: 'pakketten worden niet gescand tussen sorteercentra.',
    patience_reason_hub: 'de verwerking in het sorteercentrum kan enkele uren duren.',
    patience_reason_local: 'je lokale bezorger voert de distributiescans uit.'
  },
  /* ─── POLONAIS ─── */
  pl: {
    locale_date: 'pl-PL',
    step_1_title: 'Zamówienie potwierdzone',
    step_1_desc: 'Dziękujemy za zaufanie! Płatność została potwierdzona, a zamówienie zarejestrowane.',
    step_2_title: 'W przygotowaniu',
    step_2_desc: 'Twoje zamówienie jest przygotowywane przez nasz zespół. Zostanie wysłane wkrótce.',
    step_3_title: 'Paczka wysłana',
    step_3_desc: 'Twoje zamówienie zostało wysłane! Możesz teraz śledzić jego podróż krok po kroku.',
    step_4_title: 'Paczka odebrana',
    step_4_desc: 'Twoja paczka została przekazana naszemu przewoźnikowi, a śledzenie jest aktywne.',
    step_5_title: 'W drodze do Ciebie',
    step_5_desc: 'Twoja paczka jest w drodze. Każdy krok przybliża ją do Ciebie.',
    step_6_title: 'W tranzycie',
    step_6_desc: 'Twoja paczka posuwa się krok po kroku. Między aktualizacjami może minąć kilka dni — to zupełnie normalne.',
    step_7_title: 'Dotarła do Twojego regionu',
    step_7_desc: 'Dobra wiadomość: Twoja paczka dotarła do Twojego regionu. Jest w ostatniej fazie przed dostawą.',
    step_8_title: 'Ostatnia kontrola',
    step_8_desc: 'Przeprowadzamy ostatnią kontrolę, aby upewnić się, że paczka dotrze w najlepszym stanie. Jeszcze kilka kroków!',
    step_9_title: 'W drodze do Twojego miasta',
    step_9_desc: 'Twoja paczka zbliża się do Twojego adresu. Dostawa jest coraz bliżej.',
    step_10_title: 'Prawie u Ciebie',
    step_10_desc: 'Twoja paczka dotarła do Twojej strefy dostawy. Kurier odbierze ją wkrótce — prawie gotowe!',
    step_11_title: 'W dostawie',
    step_11_desc: 'Dziś jest ten dzień: Twój kurier jest w trasie z Twoją paczką. Bądź w pobliżu, zamówienie dotrze dziś!',
    step_12_title: 'Twoje zamówienie dotarło',
    step_12_desc: 'Twoje zamówienie zostało dostarczone! Mamy nadzieję, że bransoletka Ci się spodoba. Pytania? Nasz zespół jest do Twojej dyspozycji.',
    badge_transit: 'W drodze',
    badge_delivered: 'Dostarczono',
    badge_preparing: 'W przygotowaniu',
    badge_priority: 'Uzupełnianie zapasów',
    badge_shipped: 'Wysłano',
    badge_pickup: 'W dostawie',
    badge_undelivered: 'Dostawa do przełożenia',
    badge_exception: 'W weryfikacji',
    badge_late: 'Opóźnione',
    badge_default: 'W toku',
    pre_preparing: 'Twoje zamówienie zostało odebrane i jest przygotowywane przez nasz zespół. Otrzymasz powiadomienie po wysyłce.',
    pre_finalizing: 'Twoje zamówienie jest finalizowane przed wysyłką. Paczka będzie wkrótce w drodze.',
    pre_restock: 'Ten model cieszy się ogromnym powodzeniem, a nasz zespół przygotowuje Twoje zamówienie z największą starannością. Szacowana data uwzględnia to opóźnienie.',
    pre_priority: 'Twoje zamówienie jest traktowane priorytetowo: nasz zespół osobiście śledzi jego wysyłkę. Pytania? Nasz dział obsługi klienta odpowie Ci priorytetowo.',
    order_placed_on: 'Złożone dnia',
    estimated_delivery: 'Szacowana dostawa',
    progress_order: 'Zamówienie',
    progress_delivery: 'Dostawa',
    tracking_number_title: 'Twój numer śledzenia',
    tracking_btn: 'Śledź paczkę w czasie rzeczywistym →',
    last_update: 'Ostatnia aktualizacja sieci:',
    last_update_less_1h: 'mniej niż godzinę temu',
    last_update_hours: '{n} godz. temu',
    last_update_date: 'dnia',
    estimate_reminder: 'Szacowana dostawa: {date}',
    contact_question: 'Pytanie dotyczące dostawy?',
    contact_link: 'Skontaktuj się z naszą obsługą klienta',
    new_search: '← Śledź inne zamówienie',
    magic_banner: 'Bezpieczny dostęp — jesteś połączony przez swój osobisty link.',
    error_invalid: 'Sprawdź swoje dane.',
    error_token: 'Nieprawidłowy lub wygasły link śledzenia.',
    error_network: 'Nie można połączyć się z usługą śledzenia. Spróbuj ponownie.',
    cancel_intro: 'Trwa to zbyt długo?',
    cancel_btn: 'Anuluj zamówienie',
    cancel_checking: 'Sprawdzanie…',
    cancel_checking_text: 'Sprawdzamy, czy Twoje zamówienie może jeszcze zostać anulowane.',
    cancel_title_priority: 'Anulowanie zamówienia',
    cancel_text_priority: 'Twoje zamówienie ma opóźnienie, którego żałujemy. Jest traktowane priorytetowo i zostanie wysłane jak najszybciej. Możesz je anulować i otrzymać pełny zwrot.',
    cancel_title_restock: 'Anulowanie zamówienia',
    cancel_text_restock: 'Twoje zamówienie jest finalizowane przed wysyłką. Możesz je anulować i otrzymać pełny zwrot w dowolnym momencie przed wysyłką.',
    cancel_keep: 'Zachowaj zamówienie',
    cancel_confirm: 'Anuluj i uzyskaj zwrot',
    cancel_impossible: 'Anulowanie niemożliwe',
    cancel_already_shipped: 'Twoje zamówienie jest już wysyłane. Automatyczne anulowanie nie jest już możliwe.',
    cancel_not_found: 'Nie znaleźliśmy Twojego zamówienia w naszym systemie.',
    cancel_error_generic: 'Błąd techniczny uniemożliwia przetworzenie Twojego żądania.',
    cancel_team_available: 'Nasz zespół jest dostępny, aby Ci pomóc.',
    cancel_contact: 'Skontaktuj się z pomocą',
    cancel_close: 'Zamknij',
    cancel_processing: 'Anulowanie w toku…',
    cancel_processing_text: 'Przetwarzamy Twoje żądanie, proszę czekać.',
    cancel_success: 'Zamówienie anulowane',
    cancel_success_text: 'Twoje zamówienie {order} zostało pomyślnie anulowane. Otrzymasz zwrot {amount} {currency} w ciągu 5-10 dni roboczych.',
    cancel_failed: 'Anulowanie nie powiodło się',
    cancel_failed_text: 'Wystąpił błąd podczas anulowania. Nasz zespół został powiadomiony i skontaktuje się z Tobą.',
    cancel_error_connection: 'Błąd połączenia',
    cancel_error_connection_text: 'Nie można połączyć się z naszą usługą. Spróbuj ponownie lub skontaktuj się z pomocą.',
    cancel_error_finalize: 'Nie można dokończyć anulowania. Skontaktuj się z naszą pomocą.',
    page_title: 'Śledzenie zamówienia',
    page_subtitle: 'Śledź w czasie rzeczywistym status wysyłki Twojej bransoletki.',
    form_title: 'Dostęp do śledzenia',
    label_email: 'Adres e-mail',
    label_order: 'Numer zamówienia',
    placeholder_email: 'twoj@email.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Śledź zamówienie',
    loader_title: 'Pobieramy najnowsze aktualizacje Twojej przesyłki…',
    loader_sub: 'To zajmie kilka sekund',
    loader_step2_msg: 'Weryfikacja zamówienia…',
    loader_step3_msg: 'Analiza danych śledzenia…',
    result_badge_default: 'W przygotowaniu',
    result_est_label: 'Szacowana dostawa',
    result_your_order: 'TWOJE ZAMÓWIENIE',
    info_tip_delay: 'Czas dostawy może się różnić w zależności od przewoźnika.',
    result_progress_order: 'Zamówienie',
    result_progress_delivery: 'Dostawa',
    result_tn_title: 'Twój numer śledzenia',
    result_tn_btn: 'Śledź paczkę w czasie rzeczywistym →',
    result_timeline_title: 'Postęp zamówienia',
    result_help: 'Pytanie dotyczące dostawy?',
    result_help_link: 'Skontaktuj się z obsługą klienta',
    result_new_search: '← Śledź inne zamówienie',
    delay_transit_late: 'Wasze ulubione bransoletki cieszyły się ogromną popularnością i musieliśmy uzupełnić zapasy przed wysyłką. Wasza paczka jest już w drodze! Dziękujemy bardzo za cierpliwość i zaufanie.',
    delivered_on: 'Dostarczono {date}',
    cs_same_info: 'Widzisz te same informacje o statusie zamówienia, do których mają dostęp nasi konsultanci obsługi klienta.',
    at_latest: 'najp\u00f3\u017aniej',
    countdown_days: 'Jeszcze oko\u0142o {n} dni.',
    countdown_day: 'Dostawa spodziewana jutro.',
    countdown_today: 'Dostawa spodziewana dzi\u015b.',
    next_step_label: 'Nast\u0119pny krok:',
    next_step_5: 'W drodze do Twojego regionu.',
    next_step_6: 'Przybycie do centrum sortowania.',
    next_step_7: 'Przekazanie lokalnemu kurierowi.',
    next_step_8: 'Odbi\u00f3r przez kuriera.',
    next_step_9: 'Dostawa pod Tw\u00f3j adres.',
    next_step_10: 'Kurier odbiera Twoj\u0105 paczk\u0119.',
    next_step_11: 'Dostawa pod Tw\u00f3j adres.',
    faq_title: 'Cz\u0119sto zadawane pytania',
    faq_q1: 'Dlaczego m\u00f3j tracking si\u0119 nie aktualizuje?',
    faq_a1: 'Przewo\u017anicy nie skanuj\u0105 paczek na ka\u017cdym etapie. To normalne, \u017ce przez 2-5 dni nie pojawia si\u0119 aktualizacja.',
    faq_q2: 'Czy moje zam\u00f3wienie mo\u017ce przyj\u015b\u0107 wcze\u015bniej?',
    faq_a2: 'Tak, to mo\u017cliwe! Zawsze robimy wszystko, aby dostarczy\u0107 jak najszybciej.',
    faq_q3: 'Co je\u015bli nie b\u0119d\u0119 dost\u0119pny?',
    faq_a3: 'Kurier zostawi awizo lub paczka zostanie dostarczona do punktu odbioru.',
    faq_q4: 'Czy mogę anulować zamówienie?',
    faq_a4: 'Po wysłaniu zamówienia nie można go już anulować. Po otrzymaniu możesz dokonać bezpłatnego zwrotu.',
    sav_help: 'Potrzebujesz pomocy? Nasz zesp\u00f3\u0142 odpowiada w ci\u0105gu 24 godzin (dni robocze).',
    patience_scan_imminent: 'Aktualizacja wkrótce — Twoja paczka jest w drodze.',
    patience_scan_hours: 'Następna aktualizacja spodziewana w ciągu najbliższych godzin.',
    patience_scan_day: 'Następna aktualizacja spodziewana do {day} wieczorem.',
    patience_benchmark: 'Zamówienia docierają średnio w {avg} dni. Twoje jest w drodze od {days} dni.',
    patience_reassurance: '{pct}% zamówień dociera w szacowanym terminie.',
    patience_scan_overdue: 'Oczekiwany skan jeszcze nie dotar\u0142 \u2014 dotyczy to {pct}% paczek na tym etapie, bez wp\u0142ywu na szacowan\u0105 dat\u0119 dostawy.',
    patience_reason_flight: 'paczki nie s\u0105 skanowane mi\u0119dzy centrami sortowania.',
    patience_reason_hub: 'przetwarzanie w centrum sortowania mo\u017ce potrwa\u0107 kilka godzin.',
    patience_reason_local: 'Tw\u00f3j lokalny kurier wykonuje skany dystrybucyjne.'
  },
  /* ─── PORTUGAIS ─── */
  pt: {
    locale_date: 'pt-PT',
    step_1_title: 'Encomenda confirmada',
    step_1_desc: 'Obrigado pela sua confiança! O seu pagamento foi confirmado e a sua encomenda registada.',
    step_2_title: 'Em preparação',
    step_2_desc: 'A sua encomenda está a ser preparada pela nossa equipa. Será enviada muito em breve.',
    step_3_title: 'Encomenda enviada',
    step_3_desc: 'A sua encomenda foi enviada! Pode agora acompanhar o seu percurso passo a passo.',
    step_4_title: 'Encomenda recolhida',
    step_4_desc: 'A sua encomenda foi entregue ao nosso transportador e o rastreamento está ativo.',
    step_5_title: 'A caminho',
    step_5_desc: 'A sua encomenda está a caminho. Cada etapa aproxima-a de si.',
    step_6_title: 'Em trânsito',
    step_6_desc: 'A sua encomenda avança etapa por etapa. Podem passar alguns dias entre atualizações — é perfeitamente normal.',
    step_7_title: 'Chegou à sua região',
    step_7_desc: 'Boas notícias: a sua encomenda chegou à sua região. Está na fase final antes da entrega.',
    step_8_title: 'Última verificação',
    step_8_desc: 'Estamos a realizar uma última verificação para garantir que a sua encomenda chega nas melhores condições. Faltam apenas alguns passos!',
    step_9_title: 'A caminho da sua cidade',
    step_9_desc: 'A sua encomenda aproxima-se da sua morada. A entrega está muito próxima.',
    step_10_title: 'Quase aí',
    step_10_desc: 'A sua encomenda chegou à sua zona de entrega. O estafeta irá recolhê-la muito em breve — está quase!',
    step_11_title: 'Em entrega',
    step_11_desc: 'Hoje é o dia: o seu estafeta está em rota com a sua encomenda. Fique por perto, a sua encomenda chega hoje!',
    step_12_title: 'A sua encomenda chegou',
    step_12_desc: 'A sua encomenda foi entregue! Esperamos que adore a sua pulseira. Questões? A nossa equipa está ao seu dispor.',
    badge_transit: 'A caminho',
    badge_delivered: 'Entregue',
    badge_preparing: 'Em preparação',
    badge_priority: 'Reabastecimento',
    badge_shipped: 'Enviada',
    badge_pickup: 'Em entrega',
    badge_undelivered: 'Entrega a reagendar',
    badge_exception: 'Em verificação',
    badge_late: 'Atrasada',
    badge_default: 'Em curso',
    pre_preparing: 'A sua encomenda foi recebida e está a ser preparada pela nossa equipa. Receberá uma notificação quando for enviada.',
    pre_finalizing: 'A sua encomenda está a ser finalizada antes do envio. Estará a caminho em breve.',
    pre_restock: 'Este modelo tem um enorme sucesso e a nossa equipa prepara a sua encomenda com o maior cuidado. A data estimada tem em conta este atraso.',
    pre_priority: 'A sua encomenda está a receber tratamento prioritário: a nossa equipa acompanha pessoalmente o envio. Questões? O nosso serviço ao cliente responde-lhe com prioridade.',
    order_placed_on: 'Realizada a',
    estimated_delivery: 'Entrega estimada',
    progress_order: 'Encomenda',
    progress_delivery: 'Entrega',
    tracking_number_title: 'O seu número de rastreamento',
    tracking_btn: 'Rastrear a minha encomenda em tempo real →',
    last_update: 'Última atualização da rede:',
    last_update_less_1h: 'há menos de uma hora',
    last_update_hours: 'há {n}h',
    last_update_date: 'a',
    estimate_reminder: 'Entrega estimada: {date}',
    contact_question: 'Uma questão sobre a sua entrega?',
    contact_link: 'Contacte o nosso serviço ao cliente',
    new_search: '← Rastrear outra encomenda',
    magic_banner: 'Acesso seguro — está ligado através do seu link pessoal.',
    error_invalid: 'Por favor, verifique os seus dados.',
    error_token: 'Link de rastreamento inválido ou expirado.',
    error_network: 'Não é possível contactar o serviço de rastreamento. Tente novamente.',
    cancel_intro: 'Está a demorar demais?',
    cancel_btn: 'Cancelar a minha encomenda',
    cancel_checking: 'A verificar…',
    cancel_checking_text: 'Estamos a verificar se a sua encomenda ainda pode ser cancelada.',
    cancel_title_priority: 'Cancelamento da sua encomenda',
    cancel_text_priority: 'A sua encomenda tem um atraso que lamentamos. Está em tratamento prioritário e será enviada o mais rápido possível. Pode cancelá-la e receber um reembolso total.',
    cancel_title_restock: 'Cancelamento da sua encomenda',
    cancel_text_restock: 'A sua encomenda está a ser finalizada antes do envio. Pode cancelá-la e receber um reembolso total a qualquer momento antes do envio.',
    cancel_keep: 'Manter a minha encomenda',
    cancel_confirm: 'Cancelar e obter reembolso',
    cancel_impossible: 'Cancelamento não possível',
    cancel_already_shipped: 'A sua encomenda já está a ser enviada. O cancelamento automático já não é possível.',
    cancel_not_found: 'Não encontrámos a sua encomenda no nosso sistema.',
    cancel_error_generic: 'Um erro técnico impede-nos de processar o seu pedido.',
    cancel_team_available: 'A nossa equipa está disponível para o ajudar.',
    cancel_contact: 'Contactar suporte',
    cancel_close: 'Fechar',
    cancel_processing: 'A cancelar…',
    cancel_processing_text: 'Estamos a processar o seu pedido, aguarde.',
    cancel_success: 'Encomenda cancelada',
    cancel_success_text: 'A sua encomenda {order} foi cancelada com sucesso. Será reembolsado {amount} {currency} dentro de 5 a 10 dias úteis.',
    cancel_failed: 'Cancelamento falhado',
    cancel_failed_text: 'Ocorreu um erro durante o cancelamento. A nossa equipa foi notificada e entrará em contacto consigo.',
    cancel_error_connection: 'Erro de ligação',
    cancel_error_connection_text: 'Não é possível contactar o nosso serviço. Tente novamente ou contacte o suporte.',
    cancel_error_finalize: 'Não foi possível concluir o cancelamento. Contacte o nosso suporte.',
    page_title: 'Rastreamento do seu pedido',
    page_subtitle: 'Acompanhe em tempo real o estado de envio da sua pulseira.',
    form_title: 'Aceder ao meu rastreamento',
    label_email: 'Endereço de email',
    label_order: 'Número do pedido',
    placeholder_email: 'seu@email.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Rastrear meu pedido',
    loader_title: 'Estamos a obter as últimas atualizações da sua entrega…',
    loader_sub: 'Isto demora alguns segundos',
    loader_step2_msg: 'Verificação da sua encomenda…',
    loader_step3_msg: 'Análise dos dados de rastreio…',
    result_badge_default: 'Em preparação',
    result_est_label: 'Entrega estimada',
    result_your_order: 'SEU PEDIDO',
    info_tip_delay: 'Os prazos podem variar conforme a transportadora.',
    result_progress_order: 'Pedido',
    result_progress_delivery: 'Entrega',
    result_tn_title: 'O seu número de rastreamento',
    result_tn_btn: 'Rastrear a minha encomenda em tempo real →',
    result_timeline_title: 'Progresso do seu pedido',
    result_help: 'Uma questão sobre a sua entrega?',
    result_help_link: 'Contacte o nosso serviço ao cliente',
    result_new_search: '← Rastrear outro pedido',
    delay_transit_late: 'As vossas pulseiras favoritas tiveram um sucesso incrível e tivemos de reabastecer antes de as enviar. A vossa encomenda já está a caminho! Muito obrigado pela vossa paciência e confiança.',
    delivered_on: 'Entregue em {date}',
    cs_same_info: 'Está a ver as mesmas informações sobre o estado da encomenda a que os nossos agentes de apoio ao cliente têm acesso.',
    at_latest: 'no m\u00e1ximo at\u00e9',
    countdown_days: 'Ainda cerca de {n} dias.',
    countdown_day: 'Entrega prevista amanh\u00e3.',
    countdown_today: 'Entrega prevista hoje.',
    next_step_label: 'Pr\u00f3ximo passo:',
    next_step_5: 'Em tr\u00e2nsito para a sua regi\u00e3o.',
    next_step_6: 'Chegada ao centro de triagem.',
    next_step_7: 'Entrega ao transportador local.',
    next_step_8: 'Recolhido pelo transportador.',
    next_step_9: 'Entrega na sua morada.',
    next_step_10: 'O estafeta est\u00e1 a recolher a sua encomenda.',
    next_step_11: 'Entrega na sua morada.',
    faq_title: 'Perguntas frequentes',
    faq_q1: 'Porque \u00e9 que o meu rastreio n\u00e3o atualiza?',
    faq_a1: 'Os transportadores n\u00e3o digitalizam as encomendas em cada etapa. \u00c9 normal n\u00e3o aparecer atualiza\u00e7\u00e3o durante 2 a 5 dias.',
    faq_q2: 'A minha encomenda pode chegar mais cedo?',
    faq_a2: 'Sim, \u00e9 poss\u00edvel! Fazemos sempre o nosso melhor para entregar o mais r\u00e1pido poss\u00edvel.',
    faq_q3: 'E se eu n\u00e3o estiver dispon\u00edvel?',
    faq_a3: 'O transportador deixar\u00e1 um aviso ou a encomenda ser\u00e1 entregue num ponto de recolha.',
    faq_q4: 'Posso cancelar a minha encomenda?',
    faq_a4: 'Depois de a encomenda ter sido enviada, já não é possível cancelá-la. Pode efetuar uma devolução gratuita após a receção.',
    sav_help: 'Precisa de ajuda? A nossa equipa responde em 24 horas (dias \u00fateis).',
    patience_scan_imminent: 'Atualização iminente — a sua encomenda está a progredir normalmente.',
    patience_scan_hours: 'Próxima atualização esperada nas próximas horas.',
    patience_scan_day: 'Próxima atualização esperada até {day} à noite.',
    patience_benchmark: 'As encomendas chegam em média em {avg} dias. A sua está a caminho há {days} dias.',
    patience_reassurance: '{pct}% das encomendas chegam dentro do prazo estimado.',
    patience_scan_overdue: 'A leitura esperada ainda n\u00e3o chegou \u2014 isto afeta {pct}% das encomendas nesta fase, sem impacto na data de entrega estimada.',
    patience_reason_flight: 'as encomendas n\u00e3o s\u00e3o digitalizadas entre centros de triagem.',
    patience_reason_hub: 'o processamento no centro de triagem pode demorar algumas horas.',
    patience_reason_local: 'o seu transportador local est\u00e1 a realizar as leituras de distribui\u00e7\u00e3o.'
  },
  /* ─── ROUMAIN ─── */
  ro: {
    locale_date: 'ro-RO',
    step_1_title: 'Comandă confirmată',
    step_1_desc: 'Mulțumim pentru încredere! Plata a fost confirmată și comanda înregistrată.',
    step_2_title: 'În pregătire',
    step_2_desc: 'Comanda dumneavoastră este pregătită de echipa noastră. Va fi expediată foarte curând.',
    step_3_title: 'Colet expediat',
    step_3_desc: 'Comanda a fost expediată! Puteți urmări traseul pas cu pas.',
    step_4_title: 'Colet preluat',
    step_4_desc: 'Coletul a fost predat curierului nostru și urmărirea este acum activă.',
    step_5_title: 'Pe drum spre dumneavoastră',
    step_5_desc: 'Coletul este pe drum. Fiecare etapă îl apropie de dumneavoastră.',
    step_6_title: 'În tranzit',
    step_6_desc: 'Coletul avansează etapă cu etapă. Pot trece câteva zile între actualizări — este perfect normal.',
    step_7_title: 'A ajuns în zona dumneavoastră',
    step_7_desc: 'Vești bune: coletul a ajuns în regiunea dumneavoastră. Se află în ultima fază înainte de livrare.',
    step_8_title: 'Ultimul control',
    step_8_desc: 'Efectuăm un ultim control pentru a ne asigura că coletul ajunge în cele mai bune condiții. Mai sunt doar câțiva pași!',
    step_9_title: 'Pe drum spre orașul dumneavoastră',
    step_9_desc: 'Coletul se apropie de adresa dumneavoastră. Livrarea este foarte aproape.',
    step_10_title: 'Aproape la destinație',
    step_10_desc: 'Coletul a ajuns în zona de livrare. Curierul îl va prelua foarte curând — aproape gata!',
    step_11_title: 'În curs de livrare',
    step_11_desc: 'Astăzi este ziua: curierul este în traseu cu coletul dumneavoastră. Rămâneți în apropiere, comanda sosește astăzi!',
    step_12_title: 'Comanda a sosit',
    step_12_desc: 'Comanda a fost livrată! Sperăm că vă place brățara. Întrebări? Echipa noastră vă stă la dispoziție.',
    badge_transit: 'Pe drum',
    badge_delivered: 'Livrat',
    badge_preparing: 'În pregătire',
    badge_priority: 'Reaprovizionare',
    badge_shipped: 'Expediat',
    badge_pickup: 'În livrare',
    badge_undelivered: 'Livrare de reprogramat',
    badge_exception: 'În verificare',
    badge_late: 'Întârziat',
    badge_default: 'În curs',
    pre_preparing: 'Comanda a fost primită și este pregătită de echipa noastră. Veți primi o notificare la expediere.',
    pre_finalizing: 'Comanda este finalizată înainte de expediere. Coletul va fi în curând pe drum.',
    pre_restock: 'Acest model are un succes enorm și echipa noastră pregătește comanda cu cea mai mare grijă. Data estimată ține cont de această întârziere.',
    pre_priority: 'Comanda primește tratament prioritar: echipa noastră urmărește personal expedierea. Întrebări? Serviciul nostru clienți vă răspunde prioritar.',
    order_placed_on: 'Plasată pe',
    estimated_delivery: 'Livrare estimată',
    progress_order: 'Comandă',
    progress_delivery: 'Livrare',
    tracking_number_title: 'Numărul de urmărire',
    tracking_btn: 'Urmărește coletul în timp real →',
    last_update: 'Ultima actualizare a rețelei:',
    last_update_less_1h: 'acum mai puțin de o oră',
    last_update_hours: 'acum {n} ore',
    last_update_date: 'pe',
    estimate_reminder: 'Livrare estimată: {date}',
    contact_question: 'O întrebare despre livrare?',
    contact_link: 'Contactați serviciul nostru clienți',
    new_search: '← Urmărește altă comandă',
    magic_banner: 'Acces securizat — sunteți conectat prin linkul personal.',
    error_invalid: 'Verificați datele dumneavoastră.',
    error_token: 'Link de urmărire invalid sau expirat.',
    error_network: 'Nu se poate contacta serviciul de urmărire. Încercați din nou.',
    cancel_intro: 'Durează prea mult?',
    cancel_btn: 'Anulează comanda',
    cancel_checking: 'Se verifică…',
    cancel_checking_text: 'Verificăm dacă comanda poate fi încă anulată.',
    cancel_title_priority: 'Anularea comenzii',
    cancel_text_priority: 'Comanda are o întârziere pe care o regretăm. Este în tratament prioritar și va fi expediată cât mai curând. O puteți anula și primi rambursare integrală.',
    cancel_title_restock: 'Anularea comenzii',
    cancel_text_restock: 'Comanda este finalizată înainte de expediere. O puteți anula și primi rambursare integrală oricând înainte de expediere.',
    cancel_keep: 'Păstrează comanda',
    cancel_confirm: 'Anulează și primește rambursare',
    cancel_impossible: 'Anulare imposibilă',
    cancel_already_shipped: 'Comanda este deja în curs de expediere. Anularea automată nu mai este posibilă.',
    cancel_not_found: 'Nu am găsit comanda în sistemul nostru.',
    cancel_error_generic: 'O eroare tehnică ne împiedică să procesăm cererea.',
    cancel_team_available: 'Echipa noastră este disponibilă să vă ajute.',
    cancel_contact: 'Contactați suportul',
    cancel_close: 'Închide',
    cancel_processing: 'Se anulează…',
    cancel_processing_text: 'Procesăm cererea, vă rugăm așteptați.',
    cancel_success: 'Comandă anulată',
    cancel_success_text: 'Comanda {order} a fost anulată cu succes. Veți fi rambursat {amount} {currency} în 5-10 zile lucrătoare.',
    cancel_failed: 'Anulare eșuată',
    cancel_failed_text: 'A apărut o eroare la anulare. Echipa noastră a fost notificată și vă va contacta.',
    cancel_error_connection: 'Eroare de conexiune',
    cancel_error_connection_text: 'Nu se poate contacta serviciul nostru. Încercați din nou sau contactați suportul.',
    cancel_error_finalize: 'Nu s-a putut finaliza anularea. Contactați suportul nostru.',
    page_title: 'Urmărirea comenzii',
    page_subtitle: 'Urmăriți în timp real starea expedierii brățării dumneavoastră.',
    form_title: 'Accesați urmărirea',
    label_email: 'Adresă de email',
    label_order: 'Număr comandă',
    placeholder_email: 'email@dvs.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Urmărește comanda',
    loader_title: 'Obținem ultimele actualizări ale livrării…',
    loader_sub: 'Durează câteva secunde',
    loader_step2_msg: 'Verificarea comenzii…',
    loader_step3_msg: 'Analiza datelor de urmărire…',
    result_badge_default: 'În pregătire',
    result_est_label: 'Livrare estimată',
    result_your_order: 'COMANDA DVS.',
    info_tip_delay: 'Termenele de livrare pot varia în funcție de curier.',
    result_progress_order: 'Comandă',
    result_progress_delivery: 'Livrare',
    result_tn_title: 'Numărul de urmărire',
    result_tn_btn: 'Urmărește coletul în timp real →',
    result_timeline_title: 'Progresul comenzii',
    result_help: 'O întrebare despre livrare?',
    result_help_link: 'Contactați serviciul nostru clienți',
    result_new_search: '← Urmărește altă comandă',
    delay_transit_late: 'Brățările voastre preferate au avut un succes incredibil și a trebuit să ne reaprovizionăm înainte de a vi le trimite. Coletul vostru este acum pe drum! Vă mulțumim foarte mult pentru răbdare și încredere.',
    delivered_on: 'Livrat pe {date}',
    cs_same_info: 'Vedeți aceleași informații despre starea comenzii la care au acces și agenții noștri de serviciu clienți.',
    at_latest: 'cel t\u00e2rziu pe',
    countdown_days: '\u00cenc\u0103 aproximativ {n} zile.',
    countdown_day: 'Livrare prev\u0103zut\u0103 m\u00e2ine.',
    countdown_today: 'Livrare prev\u0103zut\u0103 ast\u0103zi.',
    next_step_label: 'Urm\u0103torul pas:',
    next_step_5: '\u00cen tranzit c\u0103tre zona dumneavoastr\u0103.',
    next_step_6: 'Sosire la centrul de sortare.',
    next_step_7: 'Predare c\u0103tre curierul local.',
    next_step_8: 'Preluat de curier.',
    next_step_9: 'Livrare la adresa dumneavoastr\u0103.',
    next_step_10: 'Curierul preia coletul dumneavoastr\u0103.',
    next_step_11: 'Livrare la adresa dumneavoastr\u0103.',
    faq_title: '\u00centreb\u0103ri frecvente',
    faq_q1: 'De ce nu se actualizeaz\u0103 urm\u0103rirea?',
    faq_a1: 'Curierii nu scaneaz\u0103 coletele la fiecare pas. Este normal s\u0103 nu apar\u0103 actualiz\u0103ri timp de 2-5 zile.',
    faq_q2: 'Poate ajunge comanda mai devreme?',
    faq_a2: 'Da, este posibil! Facem \u00eentotdeauna tot posibilul pentru a livra c\u00e2t mai repede.',
    faq_q3: 'Ce se \u00eent\u00e2mpl\u0103 dac\u0103 nu sunt acas\u0103?',
    faq_a3: 'Curierul va l\u0103sa un aviz sau coletul va fi livrat la un punct de ridicare.',
    faq_q4: 'Pot anula comanda mea?',
    faq_a4: 'Odată ce comanda a fost expediată, nu mai poate fi anulată. Puteți face o returnare gratuită după primire.',
    sav_help: 'Ave\u021bi nevoie de ajutor? Echipa noastr\u0103 r\u0103spunde \u00een 24 de ore (zile lucr\u0103toare).',
    patience_scan_imminent: 'Actualizare iminentă — coletul dumneavoastră progresează normal.',
    patience_scan_hours: 'Următoarea actualizare este așteptată în următoarele ore.',
    patience_scan_day: 'Următoarea actualizare este așteptată până {day} seara.',
    patience_benchmark: 'Comenzile ajung în medie în {avg} zile. A dumneavoastră este pe drum de {days} zile.',
    patience_reassurance: '{pct}% din comenzi ajung în termenul estimat.',
    patience_scan_overdue: 'Scanarea a\u0219teptat\u0103 nu a sosit \u00eenc\u0103 \u2014 acest lucru afecteaz\u0103 {pct}% din colete \u00een aceast\u0103 etap\u0103, f\u0103r\u0103 impact asupra datei estimate de livrare.',
    patience_reason_flight: 'coletele nu sunt scanate \u00eentre centrele de sortare.',
    patience_reason_hub: 'procesarea \u00een centrul de sortare poate dura c\u00e2teva ore.',
    patience_reason_local: 'curierul dumneavoastr\u0103 local efectueaz\u0103 scan\u0103rile de distribu\u021bie.'
  },
  /* ─── SUÉDOIS ─── */
  sv: {
    locale_date: 'sv-SE',
    step_1_title: 'Beställning bekräftad',
    step_1_desc: 'Tack för ditt förtroende! Din betalning har bekräftats och din beställning registrerats.',
    step_2_title: 'Under förberedelse',
    step_2_desc: 'Din beställning förbereds av vårt team. Den kommer att skickas mycket snart.',
    step_3_title: 'Paket skickat',
    step_3_desc: 'Din beställning har skickats! Du kan nu följa dess resa steg för steg.',
    step_4_title: 'Paket hämtat',
    step_4_desc: 'Ditt paket har överlämnats till vår transportör och spårning är nu aktiv.',
    step_5_title: 'På väg till dig',
    step_5_desc: 'Ditt paket är på väg. Varje steg för det närmare dig.',
    step_6_title: 'Under transport',
    step_6_desc: 'Ditt paket rör sig steg för steg. Det kan gå några dagar mellan uppdateringar — det är helt normalt.',
    step_7_title: 'Ankommit till ditt område',
    step_7_desc: 'Goda nyheter: ditt paket har ankommit till din region. Det är i den sista fasen före leverans.',
    step_8_title: 'Sista kontrollen',
    step_8_desc: 'Vi utför en sista kontroll för att säkerställa att ditt paket anländer i bästa skick. Bara några steg kvar!',
    step_9_title: 'På väg till din stad',
    step_9_desc: 'Ditt paket närmar sig din adress. Leveransen är nära.',
    step_10_title: 'Nästan framme',
    step_10_desc: 'Ditt paket har ankommit till ditt leveransområde. Din bud hämtar det mycket snart — det är nästan klart!',
    step_11_title: 'Ute för leverans',
    step_11_desc: 'Idag är dagen: din bud är ute med ditt paket. Stanna i närheten, din beställning kommer idag!',
    step_12_title: 'Din beställning har ankommit',
    step_12_desc: 'Din beställning har levererats! Vi hoppas att du älskar ditt armband. Frågor? Vårt team finns här för dig.',
    badge_transit: 'På väg',
    badge_delivered: 'Levererad',
    badge_preparing: 'Under förberedelse',
    badge_priority: 'Påfyllning',
    badge_shipped: 'Skickad',
    badge_pickup: 'Ute för leverans',
    badge_undelivered: 'Leverans att omboka',
    badge_exception: 'Under granskning',
    badge_late: 'Försenad',
    badge_default: 'Pågår',
    pre_preparing: 'Din beställning har mottagits och förbereds av vårt team. Du får en avisering när den skickas.',
    pre_finalizing: 'Din beställning slutförs innan leverans. Ditt paket är snart på väg.',
    pre_restock: 'Denna modell är extremt populär och vårt team förbereder din beställning med största omsorg. Det beräknade datumet tar hänsyn till denna fördröjning.',
    pre_priority: 'Din beställning får prioriterad behandling: vårt team följer personligen dess leverans. Frågor? Vår kundtjänst svarar dig med prioritet.',
    order_placed_on: 'Beställd den',
    estimated_delivery: 'Beräknad leverans',
    progress_order: 'Beställning',
    progress_delivery: 'Leverans',
    tracking_number_title: 'Ditt spårningsnummer',
    tracking_btn: 'Spåra mitt paket i realtid →',
    last_update: 'Senaste nätverksuppdatering:',
    last_update_less_1h: 'för mindre än en timme sedan',
    last_update_hours: 'för {n} timmar sedan',
    last_update_date: 'den',
    estimate_reminder: 'Beräknad leverans: {date}',
    contact_question: 'En fråga om din leverans?',
    contact_link: 'Kontakta vår kundtjänst',
    new_search: '← Spåra en annan beställning',
    magic_banner: 'Säker åtkomst — du är ansluten via din personliga länk.',
    error_invalid: 'Kontrollera dina uppgifter.',
    error_token: 'Ogiltig eller utgången spårningslänk.',
    error_network: 'Kan inte nå spårningstjänsten. Försök igen.',
    cancel_intro: 'Tar det för lång tid?',
    cancel_btn: 'Avbryt min beställning',
    cancel_checking: 'Kontrollerar…',
    cancel_checking_text: 'Vi kontrollerar om din beställning fortfarande kan avbrytas.',
    cancel_title_priority: 'Avbrytning av din beställning',
    cancel_text_priority: 'Din beställning har en försening som vi beklagar. Den behandlas med prioritet och skickas så snart som möjligt. Du kan avbryta den och få full återbetalning.',
    cancel_title_restock: 'Avbrytning av din beställning',
    cancel_text_restock: 'Din beställning slutförs innan leverans. Du kan avbryta den och få full återbetalning när som helst innan den skickas.',
    cancel_keep: 'Behåll min beställning',
    cancel_confirm: 'Avbryt och få återbetalning',
    cancel_impossible: 'Avbrytning inte möjlig',
    cancel_already_shipped: 'Din beställning skickas redan. Automatisk avbrytning är inte längre möjlig.',
    cancel_not_found: 'Vi kunde inte hitta din beställning i vårt system.',
    cancel_error_generic: 'Ett tekniskt fel hindrar oss från att behandla din begäran.',
    cancel_team_available: 'Vårt team finns tillgängligt för att hjälpa dig.',
    cancel_contact: 'Kontakta support',
    cancel_close: 'Stäng',
    cancel_processing: 'Avbryter…',
    cancel_processing_text: 'Vi behandlar din begäran, vänligen vänta.',
    cancel_success: 'Beställning avbruten',
    cancel_success_text: 'Din beställning {order} har avbrutits framgångsrikt. Du kommer att återbetalas {amount} {currency} inom 5 till 10 arbetsdagar.',
    cancel_failed: 'Avbrytning misslyckades',
    cancel_failed_text: 'Ett fel uppstod vid avbrytningen. Vårt team har meddelats och kommer att kontakta dig.',
    cancel_error_connection: 'Anslutningsfel',
    cancel_error_connection_text: 'Kan inte nå vår tjänst. Försök igen eller kontakta support.',
    cancel_error_finalize: 'Kan inte slutföra avbrytningen. Kontakta vår support.',
    page_title: 'Spåra din beställning',
    page_subtitle: 'Följ leveransstatusen för ditt armband i realtid.',
    form_title: 'Åtkomst till min spårning',
    label_email: 'E-postadress',
    label_order: 'Beställningsnummer',
    placeholder_email: 'din@email.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Spåra min beställning',
    loader_title: 'Vi hämtar de senaste uppdateringarna om din leverans…',
    loader_sub: 'Det tar några sekunder',
    loader_step2_msg: 'Verifierar din beställning…',
    loader_step3_msg: 'Analyserar spårningsdata…',
    result_badge_default: 'Under förberedelse',
    result_est_label: 'Beräknad leverans',
    result_your_order: 'DIN BESTÄLLNING',
    info_tip_delay: 'Leveranstider kan variera beroende på transportör.',
    result_progress_order: 'Beställning',
    result_progress_delivery: 'Leverans',
    result_tn_title: 'Ditt spårningsnummer',
    result_tn_btn: 'Spåra mitt paket i realtid →',
    result_timeline_title: 'Beställningsframsteg',
    result_help: 'En fråga om din leverans?',
    result_help_link: 'Kontakta vår kundtjänst',
    result_new_search: '← Spåra en annan beställning',
    delay_transit_late: 'Era favoritarmband har varit otroligt populära och vi behövde fylla på lagret innan vi kunde skicka era. Ert paket är nu på väg! Tack så mycket för ert tålamod och förtroende.',
    delivered_on: 'Levererat den {date}',
    cs_same_info: 'Du ser samma orderstatusinformation som våra kundtjänstmedarbetare har tillgång till.',
    at_latest: 'senast den',
    countdown_days: 'Cirka {n} dagar kvar.',
    countdown_day: 'Leverans f\u00f6rv\u00e4ntas imorgon.',
    countdown_today: 'Leverans f\u00f6rv\u00e4ntas idag.',
    next_step_label: 'N\u00e4sta steg:',
    next_step_5: 'P\u00e5 v\u00e4g till ditt omr\u00e5de.',
    next_step_6: 'Ankomst till sorteringscentret.',
    next_step_7: '\u00d6verl\u00e4mning till din lokala transport\u00f6r.',
    next_step_8: 'Upph\u00e4mtad av din transport\u00f6r.',
    next_step_9: 'Leverans till din adress.',
    next_step_10: 'Din chauff\u00f6r h\u00e4mtar ditt paket.',
    next_step_11: 'Leverans till din adress.',
    faq_title: 'Vanliga fr\u00e5gor',
    faq_q1: 'Varf\u00f6r uppdateras inte min sp\u00e5rning?',
    faq_a1: 'Transport\u00f6rer skannar inte paket vid varje steg. Det \u00e4r normalt att ingen uppdatering visas under 2-5 dagar.',
    faq_q2: 'Kan min best\u00e4llning komma tidigare?',
    faq_a2: 'Ja, det \u00e4r m\u00f6jligt! Vi g\u00f6r alltid v\u00e5rt b\u00e4sta f\u00f6r att leverera s\u00e5 snabbt som m\u00f6jligt.',
    faq_q3: 'Vad h\u00e4nder om jag inte \u00e4r hemma?',
    faq_a3: 'Transport\u00f6ren l\u00e4mnar ett meddelande eller ditt paket levereras till ett utl\u00e4mningsst\u00e4lle.',
    faq_q4: 'Kan jag avbryta min beställning?',
    faq_a4: 'När din beställning har skickats kan den inte längre avbrytas. Du kan göra en gratis retur efter mottagande.',
    sav_help: 'Beh\u00f6ver du hj\u00e4lp? V\u00e5rt team svarar inom 24 timmar (vardagar).',
    patience_scan_imminent: 'Uppdatering kommer snart — ditt paket är på väg.',
    patience_scan_hours: 'Nästa uppdatering förväntas inom de närmaste timmarna.',
    patience_scan_day: 'Nästa uppdatering förväntas senast {day} kväll.',
    patience_benchmark: 'Beställningar anländer i genomsnitt på {avg} dagar. Din har varit på väg i {days} dagar.',
    patience_reassurance: '{pct}% av beställningarna anländer inom den beräknade leveranstiden.',
    patience_scan_overdue: 'Den f\u00f6rv\u00e4ntade skanningen har \u00e4nnu inte kommit \u2014 detta g\u00e4ller {pct}% av paketen i detta steg, utan p\u00e5verkan p\u00e5 det ber\u00e4knade leveransdatumet.',
    patience_reason_flight: 'paket skannas inte mellan sorteringscentra.',
    patience_reason_hub: 'bearbetningen vid sorteringscentret kan ta n\u00e5gra timmar.',
    patience_reason_local: 'din lokala transportf\u00f6retag utf\u00f6r distributionsskanningar.'
  },
  /* ─── TCHÈQUE ─── */
  cs: {
    locale_date: 'cs-CZ',
    step_1_title: 'Objednávka potvrzena',
    step_1_desc: 'Děkujeme za důvěru! Vaše platba byla potvrzena a objednávka zaregistrována.',
    step_2_title: 'Připravuje se',
    step_2_desc: 'Vaše objednávka je připravována naším týmem. Bude odeslána velmi brzy.',
    step_3_title: 'Zásilka odeslána',
    step_3_desc: 'Vaše objednávka byla odeslána! Nyní můžete sledovat její cestu krok za krokem.',
    step_4_title: 'Zásilka vyzvednuta',
    step_4_desc: 'Vaše zásilka byla předána našemu přepravci a sledování je nyní aktivní.',
    step_5_title: 'Na cestě k vám',
    step_5_desc: 'Vaše zásilka je na cestě. Každý krok ji přibližuje k vám.',
    step_6_title: 'V přepravě',
    step_6_desc: 'Vaše zásilka postupuje krok za krokem. Mezi aktualizacemi může uplynout několik dní — to je zcela normální.',
    step_7_title: 'Dorazila do vaší oblasti',
    step_7_desc: 'Dobrá zpráva: vaše zásilka dorazila do vašeho regionu. Je v poslední fázi před doručením.',
    step_8_title: 'Poslední kontrola',
    step_8_desc: 'Provádíme poslední kontrolu, abychom zajistili, že zásilka dorazí v nejlepším stavu. Už jen pár kroků!',
    step_9_title: 'Na cestě do vašeho města',
    step_9_desc: 'Vaše zásilka se blíží k vaší adrese. Doručení se rychle blíží.',
    step_10_title: 'Téměř u vás',
    step_10_desc: 'Vaše zásilka dorazila do vaší doručovací zóny. Kurýr ji velmi brzy vyzvedne — je to skoro hotovo!',
    step_11_title: 'Doručuje se',
    step_11_desc: 'Dnes je ten den: váš kurýr je na cestě s vaší zásilkou. Zůstaňte poblíž, objednávka dorazí dnes!',
    step_12_title: 'Vaše objednávka dorazila',
    step_12_desc: 'Vaše objednávka byla doručena! Doufáme, že se vám náramek bude líbit. Otázky? Náš tým je tu pro vás.',
    badge_transit: 'Na cestě',
    badge_delivered: 'Doručeno',
    badge_preparing: 'Připravuje se',
    badge_priority: 'Doplňování',
    badge_shipped: 'Odesláno',
    badge_pickup: 'Doručuje se',
    badge_undelivered: 'Doručení k přeplánování',
    badge_exception: 'Probíhá kontrola',
    badge_late: 'Zpožděno',
    badge_default: 'Probíhá',
    pre_preparing: 'Vaše objednávka byla přijata a je připravována naším týmem. Obdržíte oznámení po odeslání.',
    pre_finalizing: 'Vaše objednávka je dokončována před odesláním. Zásilka bude brzy na cestě.',
    pre_restock: 'Tento model je extrémně populární a náš tým připravuje vaši objednávku s největší péčí. Odhadované datum zohledňuje toto zpoždění.',
    pre_priority: 'Vaše objednávka dostává prioritní zacházení: náš tým osobně sleduje její odeslání. Otázky? Náš zákaznický servis vám odpoví přednostně.',
    order_placed_on: 'Objednáno dne',
    estimated_delivery: 'Odhadované doručení',
    progress_order: 'Objednávka',
    progress_delivery: 'Doručení',
    tracking_number_title: 'Vaše sledovací číslo',
    tracking_btn: 'Sledovat zásilku v reálném čase →',
    last_update: 'Poslední aktualizace sítě:',
    last_update_less_1h: 'před méně než hodinou',
    last_update_hours: 'před {n} hod.',
    last_update_date: 'dne',
    estimate_reminder: 'Očekávané doručení: {date}',
    contact_question: 'Dotaz k vaší zásilce?',
    contact_link: 'Kontaktujte náš zákaznický servis',
    new_search: '← Sledovat jinou objednávku',
    magic_banner: 'Zabezpečený přístup — jste připojeni přes svůj osobní odkaz.',
    error_invalid: 'Zkontrolujte prosím své údaje.',
    error_token: 'Neplatný nebo vypršelý sledovací odkaz.',
    error_network: 'Nelze kontaktovat sledovací službu. Zkuste to znovu.',
    cancel_intro: 'Trvá to příliš dlouho?',
    cancel_btn: 'Zrušit objednávku',
    cancel_checking: 'Kontrola…',
    cancel_checking_text: 'Kontrolujeme, zda lze vaši objednávku ještě zrušit.',
    cancel_title_priority: 'Zrušení objednávky',
    cancel_text_priority: 'Vaše objednávka má zpoždění, které nás mrzí. Je v prioritním zpracování a bude odeslána co nejdříve. Můžete ji zrušit a obdržet plnou náhradu.',
    cancel_title_restock: 'Zrušení objednávky',
    cancel_text_restock: 'Vaše objednávka je dokončována před odesláním. Můžete ji kdykoli před odesláním zrušit a obdržet plnou náhradu.',
    cancel_keep: 'Ponechat objednávku',
    cancel_confirm: 'Zrušit a získat náhradu',
    cancel_impossible: 'Zrušení není možné',
    cancel_already_shipped: 'Vaše objednávka je již odesílána. Automatické zrušení již není možné.',
    cancel_not_found: 'Vaši objednávku jsme v našem systému nenašli.',
    cancel_error_generic: 'Technická chyba nám brání zpracovat váš požadavek.',
    cancel_team_available: 'Náš tým je k dispozici, aby vám pomohl.',
    cancel_contact: 'Kontaktovat podporu',
    cancel_close: 'Zavřít',
    cancel_processing: 'Ruší se…',
    cancel_processing_text: 'Zpracováváme váš požadavek, prosím čekejte.',
    cancel_success: 'Objednávka zrušena',
    cancel_success_text: 'Vaše objednávka {order} byla úspěšně zrušena. Bude vám vráceno {amount} {currency} do 5 až 10 pracovních dnů.',
    cancel_failed: 'Zrušení se nezdařilo',
    cancel_failed_text: 'Při rušení došlo k chybě. Náš tým byl informován a bude vás kontaktovat.',
    cancel_error_connection: 'Chyba připojení',
    cancel_error_connection_text: 'Nelze kontaktovat naši službu. Zkuste to znovu nebo kontaktujte podporu.',
    cancel_error_finalize: 'Nelze dokončit zrušení. Kontaktujte naši podporu.',
    page_title: 'Sledování objednávky',
    page_subtitle: 'Sledujte v reálném čase stav doručení vašeho náramku.',
    form_title: 'Přístup ke sledování',
    label_email: 'E-mailová adresa',
    label_order: 'Číslo objednávky',
    placeholder_email: 'vas@email.com',
    placeholder_order: 'LBDB12345',
    btn_submit: 'Sledovat objednávku',
    loader_title: 'Načítáme nejnovější aktualizace vaší zásilky…',
    loader_sub: 'Trvá to několik sekund',
    loader_step2_msg: 'Ověřování vaší objednávky…',
    loader_step3_msg: 'Analýza sledovacích dat…',
    result_badge_default: 'Připravuje se',
    result_est_label: 'Odhadované doručení',
    result_your_order: 'VAŠE OBJEDNÁVKA',
    info_tip_delay: 'Dodací lhůty se mohou lišit v závislosti na dopravci.',
    result_progress_order: 'Objednávka',
    result_progress_delivery: 'Doručení',
    result_tn_title: 'Vaše sledovací číslo',
    result_tn_btn: 'Sledovat zásilku v reálném čase →',
    result_timeline_title: 'Průběh objednávky',
    result_help: 'Dotaz k vaší zásilce?',
    result_help_link: 'Kontaktujte náš zákaznický servis',
    result_new_search: '← Sledovat jinou objednávku',
    delay_transit_late: 'Vaše oblíbené náramky měly neuvěřitelný úspěch a museli jsme doplnit zásoby, než jsme je mohli odeslat. Váš balíček je nyní na cestě! Moc děkujeme za vaši trpělivost a důvěru.',
    delivered_on: 'Doručeno {date}',
    cs_same_info: 'Zobrazujete stejné informace o stavu objednávky, ke kterým mají přístup naši agenti zákaznického servisu.',
    at_latest: 'nejpozději',
    countdown_days: 'Ještě přibližně {n} dní.',
    countdown_day: 'Doručení očekáváno zítra.',
    countdown_today: 'Doručení očekáváno dnes.',
    next_step_label: 'Další krok:',
    next_step_5: 'Na cestě do vašeho regionu.',
    next_step_6: 'Příjezd do třídícího centra.',
    next_step_7: 'Předání místnímu dopravci.',
    next_step_8: 'Vyzvednuto dopravcem.',
    next_step_9: 'Doručení na vaši adresu.',
    next_step_10: 'Váš kurýr vyzvedává váš balík.',
    next_step_11: 'Doručení na vaši adresu.',
    faq_title: 'Časté dotazy',
    faq_q1: 'Proč se mé sledování neaktualizuje?',
    faq_a1: 'Dopravci neskenují balíky při každém kroku. Je normální, že se 2-5 dní neobjeví žádná aktualizace.',
    faq_q2: 'Může má objednávka dorazit dříve?',
    faq_a2: 'Ano, je to možné! Vždy děláme maximum pro co nejrychlejší doručení.',
    faq_q3: 'Co když nebudu doma?',
    faq_a3: 'Dopravce zanechá oznámení nebo bude balík doručen na výdejní místo.',
    faq_q4: 'Mohu zrušit svou objednávku?',
    faq_a4: 'Jakmile je vaše objednávka odeslána, nelze ji již zrušit. Po přijetí můžete provést bezplatnou reklamaci.',
    sav_help: 'Potřebujete pomoc? Náš tým odpovídá do 24 hodin (pracovní dny).',
    patience_scan_imminent: 'Aktualizace se očekává brzy — vaše zásilka postupuje normálně.',
    patience_scan_hours: 'Další aktualizace se očekává během několika hodin.',
    patience_scan_day: 'Další aktualizace se očekává nejpozději do {day} večer.',
    patience_benchmark: 'Objednávky dorazí v průměru za {avg} dní. Vaše je na cestě {days} dní.',
    patience_reassurance: '{pct}% objednávek dorazí v odhadovaném termínu.',
    patience_scan_overdue: 'Očekávaná aktualizace zatím nedorazila.',
    patience_reason_flight: 'zásilky nejsou skenovány mezi třídicími centry.',
    patience_reason_hub: 'zpracování v třídicím centru může trvat několik hodin.',
    patience_reason_local: 'místní dopravce provádí distribuční skeny.'
  }
};

/* ─── Détection de la langue ─── */
function lbdbDetectLang() {
  /* 1. Attribut lang du <html> (Shopify le définit automatiquement) */
  var htmlLang = (document.documentElement.lang || '').toLowerCase().split('-')[0];
  if (LBDB_I18N[htmlLang]) return htmlLang;

  /* 2. Chemin URL (ex: /de/, /en/, /es/) */
  var pathMatch = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
  if (pathMatch && LBDB_I18N[pathMatch[1]]) return pathMatch[1];

  /* 3. Shopify.locale (si disponible) */
  if (typeof Shopify !== 'undefined' && Shopify.locale) {
    var shopLang = Shopify.locale.toLowerCase().split('-')[0];
    if (LBDB_I18N[shopLang]) return shopLang;
  }

  /* 4. Fallback */
  return 'fr';
}

/* ─── Helper de traduction ─── */
function lbdbT(key, params) {
  var lang = window.__lbdbLang || 'fr';
  var dict = LBDB_I18N[lang] || LBDB_I18N.fr;
  var str = dict[key] || LBDB_I18N.fr[key] || key;
  if (params) {
    Object.keys(params).forEach(function (k) {
      str = str.replace(new RegExp('\\{' + k + '\\}', 'g'), params[k]);
    });
  }
  return str;
}
"use strict";

function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* ============================================================
   ORDER TRACKING — La Boutique du Bracelet
   Timeline 12 étapes — Mapping TrackingMore — i18n 13 langues
   ============================================================ */

(function () {
  'use strict';

  /* ---- Détection langue (doit être fait AVANT tout le reste) ---- */
  window.__lbdbLang = lbdbDetectLang();
  var LANG = window.__lbdbLang;
  var T = lbdbT; // raccourci local

  /* ---- Config ---- */
  var API_BASE = 'https://lbdb-tracking-api-production.up.railway.app';

  /*
   * 12 ÉTAPES — basées sur les données TrackingMore réelles (30 commandes livrées)
   */
  var STEPS = [{
    id: 'step_1',
    icon: '✅',
    phase: 'pre_shipment'
  }, {
    id: 'step_2',
    icon: '🎁',
    phase: 'pre_shipment'
  }, {
    id: 'step_3',
    icon: '📦',
    phase: 'pre_shipment'
  }, {
    id: 'step_4',
    icon: '🚚',
    phase: 'transit_origin'
  }, {
    id: 'step_5',
    icon: '🔄',
    phase: 'transit_origin'
  }, {
    id: 'step_6',
    icon: '🚀',
    phase: 'transit_flight'
  }, {
    id: 'step_7',
    icon: '🏠',
    phase: 'transit_hub'
  }, {
    id: 'step_8',
    icon: '🔍',
    phase: 'transit_hub'
  }, {
    id: 'step_9',
    icon: '🚚',
    phase: 'local_delivery'
  }, {
    id: 'step_10',
    icon: '📍',
    phase: 'local_delivery'
  }, {
    id: 'step_11',
    icon: '🏠',
    phase: 'local_delivery'
  }, {
    id: 'step_12',
    icon: '✨',
    phase: 'delivered'
  }];

  /*
   * FALLBACK TEMPOREL
   */
  var TIME_FALLBACK = [{
    days_min: 0,
    days_max: 0,
    step: 3
  }, {
    days_min: 1,
    days_max: 1,
    step: 4
  }, {
    days_min: 2,
    days_max: 2,
    step: 5
  }, {
    days_min: 3,
    days_max: 3,
    step: 6
  }, {
    days_min: 4,
    days_max: 4,
    step: 7
  }, {
    days_min: 5,
    days_max: 6,
    step: 8
  }, {
    days_min: 7,
    days_max: 8,
    step: 9
  }, {
    days_min: 9,
    days_max: 99,
    step: 10
  }];

  /* Pré-expédition : états spéciaux */
  var PRE_SHIPMENT_STATES = {
    preparing: {
      cls: 'state-preparing'
    },
    finalizing: {
      cls: 'state-finalizing'
    },
    restock: {
      cls: 'state-restock'
    },
    priority: {
      cls: 'state-priority'
    }
  };

  /* ---- Éléments DOM ---- */
  var authSection = document.getElementById('lbdb-auth-section');
  var resultSection = document.getElementById('lbdb-result-section');
  var loaderEl = document.getElementById('lbdb-loader');
  var errorEl = document.getElementById('lbdb-error-msg');
  var magicBanner = document.getElementById('lbdb-magic-banner');
  var emailInput = document.getElementById('lbdb-email');
  var orderInput = document.getElementById('lbdb-order-number');
  var submitBtn = document.getElementById('lbdb-submit-btn');
  // Checkpoints détaillés : choix UX — non affichés au client (données utilisées uniquement pour "Dernière mise à jour")

  if (!authSection) return;

  /* ---- Email utilisateur (stocké pour les magic links où le champ est vide) ---- */
  var __lbdbUserEmail = '';
  var API_REQUEST_TIMEOUT_MS = 15000;

  function fetchJson(url, options) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var requestOptions = Object.assign({}, options || {});
    if (controller) requestOptions.signal = controller.signal;

    return new Promise(function (resolve, reject) {
      var settled = false;
      var timeoutId = setTimeout(function () {
        if (settled) return;
        settled = true;
        if (controller) controller.abort();
        reject(new Error('request_timeout'));
      }, API_REQUEST_TIMEOUT_MS);

      fetch(url, requestOptions).then(function (response) {
        return response.text().then(function (text) {
          var data = {};
          if (text) {
            try {
              data = JSON.parse(text);
            } catch (error) {
              throw new Error('invalid_json_response');
            }
          }
          if (!data || typeof data !== 'object' || Array.isArray(data)) {
            throw new Error('invalid_json_payload');
          }
          if (!response.ok) {
            var httpError = new Error('http_' + response.status);
            httpError.status = response.status;
            httpError.publicMessage = data && data.error ? String(data.error) : '';
            throw httpError;
          }
          return data;
        });
      }).then(function (data) {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        resolve(data);
      }, function (error) {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        reject(error);
      });
    });
  }

  function assertTrackingPayload(data) {
    if (!data || typeof data.delivery_status !== 'string' ||
        typeof data.current_step !== 'number') {
      throw new Error('invalid_tracking_payload');
    }
    return data;
  }

  /* ---- Traduction des textes statiques du template Liquid ---- */
  (function translateStaticUI() {
    /* Page header */
    var h1 = document.querySelector('.lbdb-tracking-header h1');
    var subtitle = document.querySelector('.lbdb-tracking-header p');
    if (h1) h1.textContent = T('page_title');
    if (subtitle) subtitle.textContent = T('page_subtitle');

    /* Formulaire */
    var formTitle = document.querySelector('#lbdb-form-inner h2');
    if (formTitle) formTitle.textContent = T('form_title');
    var emailLabel = document.querySelector('label[for="lbdb-email"]');
    var orderLabel = document.querySelector('label[for="lbdb-order-number"]');
    if (emailLabel) emailLabel.textContent = T('label_email');
    if (orderLabel) orderLabel.textContent = T('label_order');
    if (emailInput) emailInput.placeholder = T('placeholder_email');
    if (orderInput) orderInput.placeholder = T('placeholder_order');
    if (submitBtn) submitBtn.textContent = T('btn_submit');

    /* Loader */
    var loaderTitle = document.querySelector('.lbdb-loader-title');
    var loaderSub = document.querySelector('.lbdb-loader-sub');
    if (loaderTitle) loaderTitle.textContent = T('loader_title');
    if (loaderSub) loaderSub.textContent = T('loader_sub');

    /* Section résultats - textes statiques */
    var orderLabel2 = document.querySelector('.lhc-section-label:not(.lhc-label-est) span');
    if (orderLabel2) orderLabel2.textContent = T('result_your_order');
    var badgeEl = document.getElementById('lbdb-res-status-badge');
    if (badgeEl && badgeEl.textContent.trim() === "En pr\xE9paration") {
      badgeEl.textContent = T('result_badge_default');
    }
    var estLabel = document.querySelector('.lhc-label-est span');
    if (estLabel) estLabel.textContent = T('result_est_label');

    var progressLabels = document.querySelectorAll('.lhc-progress-labels span');
    if (progressLabels.length >= 3) {
      progressLabels[0].textContent = T('result_progress_order');
      progressLabels[2].textContent = T('result_progress_delivery');
    }

    /* Tracking number card */
    var tnH3 = document.querySelector('#lbdb-tracking-number-card h3');
    var tnBtn = document.querySelector('.lbdb-btn-carrier');
    if (tnH3) tnH3.textContent = T('result_tn_title');
    if (tnBtn) tnBtn.textContent = T('result_tn_btn');

    /* Timeline title */
    var timelineH3 = document.querySelector('.lbdb-timeline-card h3');
    if (timelineH3) timelineH3.textContent = T('result_timeline_title');
  })();

  /* ---- Utilitaires ---- */
  function esc(str) {
    if (str == null) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function getLocaleDate() {
    var dict = LBDB_I18N[LANG] || LBDB_I18N.fr;
    return dict.locale_date || 'fr-FR';
  }
  function formatDate(isoStr) {
    if (!isoStr) return '';
    try {
      var date = new Date(isoStr);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleDateString(getLocaleDate(), {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    } catch (e) {
      return '';
    }
  }
  function formatDateShort(isoStr) {
    if (!isoStr) return '';
    try {
      var d = new Date(isoStr);
      if (isNaN(d)) return '';
      return d.toLocaleDateString(getLocaleDate(), {
        day: 'numeric',
        month: 'short'
      });
    } catch (e) {
      return '';
    }
  }
  function daysSince(isoStr) {
    if (!isoStr) return 0;
    try {
      var diff = Date.now() - new Date(isoStr).getTime();
      return Math.max(0, Math.floor(diff / 86400000));
    } catch (e) {
      return 0;
    }
  }
  var formInner = document.getElementById('lbdb-form-inner');
  function showError(msg) {
    if (errorEl) {
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
    }
  }
  function showResultError(msg) {
    if (!resultSection) return;
    resultSection.textContent = '';
    var message = document.createElement('p');
    message.className = 'lbdb-error-msg';
    message.style.display = 'block';
    message.style.textAlign = 'center';
    message.textContent = msg;
    resultSection.appendChild(message);
  }
  function hideError() {
    if (errorEl) errorEl.style.display = 'none';
  }
  var _loaderInterval = null;
  function setLoading(on) {
    if (formInner) formInner.style.display = on ? 'none' : 'block';
    if (loaderEl) loaderEl.style.display = on ? 'flex' : 'none';
    if (submitBtn) submitBtn.disabled = on;

    // Gestion des étapes progressives du loader
    if (on) {
      _startLoaderSteps();
    } else {
      _stopLoaderSteps();
    }
  }

  function _startLoaderSteps() {
    var steps = loaderEl ? loaderEl.querySelectorAll('.lbdb-loader-step') : [];
    var subEl = loaderEl ? loaderEl.querySelector('.lbdb-loader-sub') : null;
    if (!steps.length) return;

    // Reset toutes les étapes
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.remove('active', 'done');
    }
    steps[0].classList.add('active');

    var messages = [
      T('loader_sub'),
      T('loader_step2_msg') || 'Vérification de votre commande…',
      T('loader_step3_msg') || 'Analyse des données de suivi…',
    ];
    var currentStep = 0;

    _loaderInterval = setInterval(function() {
      currentStep++;
      if (currentStep >= steps.length) {
        clearInterval(_loaderInterval);
        _loaderInterval = null;
        return;
      }
      // Marquer l'étape précédente comme terminée
      steps[currentStep - 1].classList.remove('active');
      steps[currentStep - 1].classList.add('done');
      // Activer la nouvelle étape
      steps[currentStep].classList.add('active');
      // Mettre à jour le sous-texte
      if (subEl && messages[currentStep]) {
        subEl.style.opacity = '0';
        setTimeout(function() {
          subEl.textContent = messages[currentStep];
          subEl.style.opacity = '1';
        }, 200);
      }
    }, 4000); // Avancer toutes les 4 secondes
  }

  function _stopLoaderSteps() {
    if (_loaderInterval) {
      clearInterval(_loaderInterval);
      _loaderInterval = null;
    }
    // Marquer toutes les étapes comme terminées (effet de complétion)
    var steps = loaderEl ? loaderEl.querySelectorAll('.lbdb-loader-step') : [];
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.remove('active');
      steps[i].classList.add('done');
    }
  }

  /*
   * computeCurrentStep
   */
  function computeCurrentStep(data) {
    if (data.current_step && data.current_step >= 1 && data.current_step <= 12) {
      return data.current_step;
    }
    var status = data.delivery_status || data.pre_shipment_state || 'preparing';
    var shipDate = data.shipped_at || data.fulfillment_date;
    var daysElapsed = daysSince(shipDate);
    if (status === 'delivered') return 12;
    if (status === 'pickup') return 11;
    if (!shipDate || ['preparing', 'finalizing', 'restock', 'priority'].includes(status)) return 2;
    if (status === 'inforeceived') return 3;
    if (shipDate) {
      var _iterator = _createForOfIteratorHelper(TIME_FALLBACK),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var fb = _step.value;
          if (daysElapsed >= fb.days_min && daysElapsed <= fb.days_max) {
            return status === 'transit' ? Math.max(4, fb.step) : fb.step;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return 10;
    }
    return 3;
  }

  /* ---- Rendu de la timeline ---- */
  function renderSteps(currentStep, data) {
    var container = document.getElementById('lbdb-steps');
    if (!container) return;
    var stepDates = buildStepDates(data, currentStep);

    /* Afficher : étapes atteintes + 1 prochaine étape (grisée) */
    var maxVisible = Math.min(currentStep + 1, STEPS.length);
    container.innerHTML = STEPS.slice(0, maxVisible).map(function (step, i) {
      var n = i + 1;
      var cls = 'future';
      if (n < currentStep) cls = 'completed';else if (n === currentStep) cls = 'active';
      var dateStr = stepDates[n] || '';
      var title = T('step_' + n + '_title');
      var desc = T('step_' + n + '_desc');
      return "\n        <div class=\"lbdb-step ".concat(cls, "\">\n          <div class=\"lbdb-step-icon\">").concat(step.icon, "</div>\n          <div class=\"lbdb-step-content\">\n            <div class=\"lbdb-step-title\">").concat(title, "</div>\n            <div class=\"lbdb-step-desc\">").concat(desc, "</div>\n          </div>\n          ").concat(dateStr ? "<div class=\"lbdb-step-date\">".concat(dateStr, "</div>") : '', "\n        </div>");
    }).join('');

    /* #8: Prochaine étape (sans pays) sous l'étape active */
    if (currentStep >= 4 && currentStep < 12 && data.delivery_status !== 'delivered') {
      var nextStepKey = 'next_step_' + (currentStep + 1);
      var nextStepText = T(nextStepKey);
      if (nextStepText && nextStepText !== nextStepKey) {
        var nextStepHtml = '<div class="lbdb-next-step">' +
          '<span class="lbdb-next-step-label">' + T('next_step_label') + '</span> ' +
          '<span class="lbdb-next-step-text">' + nextStepText + '</span>' +
          '</div>';
        container.insertAdjacentHTML('beforeend', nextStepHtml);
      }
    }
  }
  function buildStepDates(data, currentStep) {
    var dates = {};

    // Étape 1 : date de commande (toujours affichée si atteinte)
    if (data.order_date && currentStep >= 1) {
      dates[1] = formatDateShort(data.order_date);
    }

    // Étapes 2-3 : préparation / expédition — UNIQUEMENT si atteintes
    if (data.fulfillment_date) {
      if (currentStep >= 3) {
        dates[3] = formatDateShort(data.fulfillment_date);
        dates[2] = dates[3];
      } else if (currentStep >= 2) {
        // En préparation : on affiche la date sur l'étape 2 seulement
        dates[2] = formatDateShort(data.order_date || data.fulfillment_date);
      }
    } else if (currentStep >= 2 && data.order_date) {
      // Pas de fulfillment_date mais étape 2 atteinte : utiliser order_date
      dates[2] = formatDateShort(data.order_date);
    }

    // Étapes 4+ : checkpoints réels (uniquement pour les étapes atteintes)
    if (data.checkpoints && data.checkpoints.length && currentStep > 3) {
      var sorted = _toConsumableArray(data.checkpoints).reverse();
      var totalCp = sorted.length;
      var stepsToFill = currentStep - 3;
      if (stepsToFill > 0 && totalCp > 0) {
        for (var s = 4; s <= currentStep; s++) {
          var cpIdx = Math.min(Math.floor((s - 4) / stepsToFill * totalCp), totalCp - 1);
          var cp = sorted[cpIdx];
          if (cp && cp.date) dates[s] = formatDateShort(cp.date);
        }
        var lastCp = sorted[totalCp - 1];
        if (lastCp && lastCp.date) dates[currentStep] = formatDateShort(lastCp.date);
      }
    }

    // Sécurité : supprimer toute date au-delà de currentStep (ne devrait pas arriver)
    for (var _s = currentStep + 1; _s <= 12; _s++) {
      delete dates[_s];
    }

    // Garantir la monotonie : une étape ne peut pas avoir une date antérieure à la précédente
    var lastDate = null;
    for (var _s2 = 1; _s2 <= currentStep; _s2++) {
      if (dates[_s2]) {
        var d = new Date(dateIsoForStep(data, _s2, dates[_s2]));
        if (lastDate && d < lastDate) {
          // Recul détecté : propager la date précédente
          dates[_s2] = dates[_s2 - 1];
        } else if (!isNaN(d)) {
          lastDate = d;
        }
      }
    }
    return dates;
  }

  // Helper : récupère la date ISO correspondant à un step pour comparaison
  function dateIsoForStep(data, step, formattedDate) {
    if (step === 1) return data.order_date;
    if (step === 2 || step === 3) return data.fulfillment_date || data.order_date;
    // Pour les étapes 4+, chercher dans les checkpoints
    if (data.checkpoints && data.checkpoints.length) {
      var sorted = _toConsumableArray(data.checkpoints).reverse();
      var totalCp = sorted.length;
      var currentStep = Math.max(step, 4);
      var stepsToFill = currentStep - 3;
      if (stepsToFill <= 0) return formattedDate;
      var cpIdx = Math.min(Math.floor((step - 4) / stepsToFill * totalCp), totalCp - 1);
      if (sorted[cpIdx] && sorted[cpIdx].date) return sorted[cpIdx].date;
    }
    return formattedDate;
  }

  /* ---- Rendu du header unifié ---- */
  function renderHeroCard(data, currentStep) {
    var numEl = document.getElementById('lbdb-res-order-num');
    var dateEl = document.getElementById('lbdb-res-order-date');
    if (numEl) {
      var on = data.order_number || '';
      numEl.textContent = on.charAt(0) === '#' ? on : '#' + on;
    }
    if (dateEl) {
      var dateSpan = dateEl.querySelector('span');
      if (dateSpan) dateSpan.textContent = data.order_date ? T('order_placed_on') + ' ' + formatDate(data.order_date) : '';
    }

    /* Badge statut */
    var badge = document.getElementById('lbdb-res-status-badge');
    var isLate = data.is_late === true || data.estimate && data.estimate.is_late === true;
    var statusMap = {
      transit: {
        cls: 'transit',
        label: T('badge_transit')
      },
      delivered: {
        cls: 'delivered',
        label: T('badge_delivered')
      },
      preparing: {
        cls: 'preparing',
        label: T('badge_preparing')
      },
      finalizing: {
        cls: 'preparing',
        label: T('badge_preparing')
      },
      restock: {
        cls: 'preparing',
        label: T('badge_preparing')
      },
      priority: {
        cls: 'urgent',
        label: T('badge_priority')
      },
      inforeceived: {
        cls: 'transit',
        label: T('badge_shipped')
      },
      pickup: {
        cls: 'transit',
        label: T('badge_pickup')
      },
      undelivered: {
        cls: 'warning',
        label: T('badge_undelivered')
      },
      exception: {
        cls: 'warning',
        label: T('badge_exception')
      }
    };
    var st = statusMap[data.delivery_status] || statusMap[data.pre_shipment_state] || {
      cls: 'preparing',
      label: T('badge_default')
    };
    if (isLate && data.delivery_status !== 'delivered') {
      st = {
        cls: 'warning',
        label: T('badge_late')
      };
    }
    if (badge) {
      badge.className = 'lbdb-status-badge ' + st.cls;
      badge.textContent = st.label;
    }

    /* Estimation */
    var estWrap = document.getElementById('lhc-estimate');
    var estDate = document.getElementById('lhc-est-date');
    var estLabel = document.querySelector('.lhc-label-est span');
    if (estWrap && data.delivery_status === 'delivered' && data.checkpoints && data.checkpoints.length) {
      /* Colis livré : afficher "Livré le [date]" au lieu de la fourchette estimée */
      var deliveredCheckpoint = data.checkpoints.find(function (checkpoint) {
        var status = checkpoint && checkpoint.status ? String(checkpoint.status).toLowerCase() : '';
        return status.indexOf('delivered') === 0 && checkpoint.date;
      });
      var deliveredDate = (deliveredCheckpoint || data.checkpoints[0]).date;
      if (estDate && deliveredDate) {
        var estTextsD = estDate.querySelector('.lhc-est-texts');
        if (estTextsD) {
          estTextsD.innerHTML = '<span class="lhc-est-main" style="color:#22c55e;">' + T('delivered_on', { date: formatDate(deliveredDate) }) + '</span>';
        }
      }
      if (estLabel) estLabel.textContent = '';
      estWrap.style.display = 'flex';
    } else if (estWrap && data.estimate && data.estimate.display) {
      var estimateDisplayValid = true;
      if (estDate) {
        /* #6: Date unique — "Lundi 20 juillet" en gros + "(au plus tard le 25 juillet)" en petit */
        var estTexts = estDate.querySelector('.lhc-est-texts');
        if (estTexts && data.estimate.date_min_iso && data.estimate.date_max_iso) {
          var dMin = new Date(data.estimate.date_min_iso + 'T12:00:00');
          var dMax = new Date(data.estimate.date_max_iso + 'T12:00:00');
          if (!isNaN(dMin.getTime()) && !isNaN(dMax.getTime())) {
            var loc = getLocaleDate();
            var mainDate = dMin.toLocaleDateString(loc, { weekday: 'long', day: 'numeric', month: 'long' });
            mainDate = mainDate.charAt(0).toUpperCase() + mainDate.slice(1);
            var maxDate = dMax.toLocaleDateString(loc, { day: 'numeric', month: 'long' });
            estTexts.innerHTML = '<span class="lhc-est-main">' + mainDate + '</span>' +
              '<span class="lhc-est-sub">(' + T('at_latest') + ' ' + maxDate + ')</span>';
          } else {
            estTexts.textContent = '';
            estimateDisplayValid = false;
          }
        } else if (estTexts) {
          estTexts.innerHTML = '<span class="lhc-est-main">' + data.estimate.display + '</span>';
        }
      }
      if (estLabel) estLabel.textContent = estimateDisplayValid ? T('estimated_delivery') : '';
      estWrap.style.display = estimateDisplayValid ? 'flex' : 'none';


    }

    /* Barre de progression */
    var progressWrap = document.getElementById('lhc-progress-wrap');
    var progressFill = document.getElementById('lhc-progress-fill');
    var progressPct = document.getElementById('lhc-progress-pct');
    if (progressWrap && progressFill) {
      var pct = Math.round((currentStep - 1) / (STEPS.length - 1) * 100);
      progressFill.style.width = '0%';
      setTimeout(function () {
        progressFill.style.width = pct + '%';
      }, 400);
      if (progressPct) progressPct.textContent = pct + '%';
    }

    /* Bandeau contextuel */
    var ctxBanner = document.getElementById('lbdb-context-banner');
    if (ctxBanner) {
      var msgText = '';
      var bannerCls = 'lbdb-context-banner';
      var showCancelBtn = ['restock', 'priority'].includes(data.pre_shipment_state);
      if (data.pre_shipment_state && PRE_SHIPMENT_STATES[data.pre_shipment_state]) {
        var ps = PRE_SHIPMENT_STATES[data.pre_shipment_state];
        msgText = T('pre_' + data.pre_shipment_state);
        bannerCls += ' ' + ps.cls;
      } else if (data.is_late && data.delay_message && data.delivery_status !== 'delivered') {
        msgText = T('delay_transit_late') !== 'delay_transit_late' ? T('delay_transit_late') : data.delay_message;
        bannerCls += ' state-late';
      }
      if (msgText) {
        ctxBanner.className = bannerCls;
        if (showCancelBtn) {
          ctxBanner.innerHTML = '<span class="lbdb-ctx-msg">' + msgText + '</span>' + '<div class="lbdb-cancel-row"><span class="lbdb-cancel-intro">' + T('cancel_intro') + '</span> ' + '<button id="lbdb-cancel-btn" class="lbdb-cancel-btn">' + T('cancel_btn') + '</button></div>';
          var cancelBtn = document.getElementById('lbdb-cancel-btn');
          if (cancelBtn) {
            cancelBtn.addEventListener('click', function () {
              return openCancelModal(data);
            });
          }
        } else {
          ctxBanner.textContent = msgText;
        }
        ctxBanner.style.display = 'block';
      } else {
        ctxBanner.style.display = 'none';
      }
    }
  }

  /* ---- Pré-vérification silencieuse ---- */
  var _cancelCheckCache = null;
  var _cancelCheckPending = false;
  function prefetchCancelCheck(_x) {
    return _prefetchCancelCheck.apply(this, arguments);
  }
  /* ---- Modal d'annulation ---- */
  function _prefetchCancelCheck() {
    _prefetchCancelCheck = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
      var orderNumber, userEmail, resp, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!(_cancelCheckPending || _cancelCheckCache)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            _cancelCheckPending = true;
            orderNumber = data.order_number || '';
            userEmail = emailInput && emailInput.value.trim() || __lbdbUserEmail || '';
            if (!(!orderNumber || !userEmail)) {
              _context.n = 2;
              break;
            }
            _cancelCheckPending = false;
            return _context.a(2);
          case 2:
            _context.p = 2;
            _context.n = 3;
            return fetch("".concat(API_BASE, "/cancel/check"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                order_number: orderNumber,
                email: userEmail
              })
            });
          case 3:
            resp = _context.v;
            if (!resp.ok) {
              _context.n = 5;
              break;
            }
            _context.n = 4;
            return resp.json();
          case 4:
            _cancelCheckCache = _context.v;
            console.log('[cancel/prefetch] résultat mis en cache:', _cancelCheckCache);
          case 5:
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t = _context.v;
            console.log('[cancel/prefetch] erreur silencieuse:', _t);
          case 7:
            _context.p = 7;
            _cancelCheckPending = false;
            return _context.f(7);
          case 8:
            return _context.a(2);
        }
      }, _callee, null, [[2, 6, 7, 8]]);
    }));
    return _prefetchCancelCheck.apply(this, arguments);
  }
  var _cancelData = null;
  function trackUiEvent(eventName, data, extra) {
    var orderNumber = data && data.order_number || '';
    var payload = {
      event: eventName,
      order_number: orderNumber,
      data: extra || '',
      source: 'page'
    };
    fetch("".concat(API_BASE, "/api/event"), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })["catch"](function () {});
  }
  function openCancelModal(data) {
    trackUiEvent('cancel_modal_open', data);
    _cancelData = data;
    var modal = document.getElementById('lbdb-cancel-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'lbdb-cancel-modal';
      modal.className = 'lbdb-cancel-modal-overlay';
      modal.innerHTML = "\n        <div class=\"lbdb-cancel-modal-box\">\n          <button class=\"lbdb-cancel-modal-close\" id=\"lbdb-cancel-modal-close\">&times;</button>\n          <div id=\"lbdb-cancel-modal-body\"></div>\n        </div>";
      document.body.appendChild(modal);
      document.getElementById('lbdb-cancel-modal-close').addEventListener('click', closeCancelModal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeCancelModal();
      });
    }
    showCancelStep1();
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
  function closeCancelModal(reason) {
    trackUiEvent('cancel_modal_close', _cancelData, reason || 'dismiss');
    var modal = document.getElementById('lbdb-cancel-modal');
    if (modal) modal.remove();
    document.body.style.overflow = '';
  }
  function showCancelStep1() {
    var body = document.getElementById('lbdb-cancel-modal-body');
    if (!body) return;
    if (_cancelCheckCache) {
      console.log('[cancel/modal] résultat depuis cache');
      _renderCancelCheckResult(_cancelCheckCache);
      return;
    }
    body.innerHTML = "\n      <div class=\"lcm-icon\">\u23F3</div>\n      <h3 class=\"lcm-title\">".concat(T('cancel_checking'), "</h3>\n      <p class=\"lcm-text\">").concat(T('cancel_checking_text'), "</p>");
    checkCancellable();
  }
  function _renderCancelCheckResult(result) {
    var data = _cancelData;
    var orderNumber = data ? data.order_number || '' : '';
    var body = document.getElementById('lbdb-cancel-modal-body');
    if (!body) return;
    if (result.cancellable) {
      trackUiEvent('cancel_check_result', _cancelData, 'cancellable=true');
      var preState = _cancelData && _cancelData.pre_shipment_state || 'restock';
      var titre, texte, btnKeep, btnCancel;
      if (preState === 'priority') {
        titre = T('cancel_title_priority');
        texte = T('cancel_text_priority');
        btnKeep = T('cancel_keep');
        btnCancel = T('cancel_confirm');
      } else {
        titre = T('cancel_title_restock');
        texte = T('cancel_text_restock');
        btnKeep = T('cancel_keep');
        btnCancel = T('cancel_confirm');
      }
      body.innerHTML = "\n          <div class=\"lcm-icon\">\uD83E\uDD0D</div>\n          <h3 class=\"lcm-title\">".concat(titre, "</h3>\n          <p class=\"lcm-text\">").concat(texte, "</p>\n          <div class=\"lcm-actions\">\n            <button class=\"lcm-btn-primary\" id=\"lcm-keep-btn\">").concat(btnKeep, "</button>\n            <button class=\"lcm-btn-ghost\" id=\"lcm-confirm-btn\">").concat(btnCancel, "</button>\n          </div>");
      document.getElementById('lcm-keep-btn').addEventListener('click', function () {
        trackUiEvent('cancel_keep_clicked', _cancelData);
        closeCancelModal('keep');
      });
      document.getElementById('lcm-confirm-btn').addEventListener('click', function () {
        trackUiEvent('cancel_confirm_clicked', _cancelData);
        confirmCancel();
      });
    } else {
      trackUiEvent('cancel_check_result', _cancelData, "cancellable=false|reason=".concat(result.reason));
      var msg = '';
      if (result.reason === 'tracking_found' || result.reason === 'already_shipped') {
        msg = T('cancel_already_shipped');
      } else if (result.reason === 'not_found') {
        msg = T('cancel_not_found');
      } else {
        msg = T('cancel_error_generic');
      }
      body.innerHTML = "\n          <div class=\"lcm-icon\">\u274C</div>\n          <h3 class=\"lcm-title\">".concat(T('cancel_impossible'), "</h3>\n          <p class=\"lcm-text\">").concat(msg, "</p>\n          <p class=\"lcm-text\">").concat(T('cancel_team_available'), "</p>\n          <div class=\"lcm-actions\">\n            <a href=\"/pages/contact\" class=\"lcm-btn-primary\">").concat(T('cancel_contact'), "</a>\n            <button class=\"lcm-btn-secondary\" id=\"lcm-close-btn2\">").concat(T('cancel_close'), "</button>\n          </div>");
      document.getElementById('lcm-close-btn2').addEventListener('click', closeCancelModal);
    }
  }
  function checkCancellable() {
    return _checkCancellable.apply(this, arguments);
  }
  function _checkCancellable() {
    _checkCancellable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var data, orderNumber, userEmail, resp, result, body, cb, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            data = _cancelData;
            if (data) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            orderNumber = data.order_number || '';
            userEmail = emailInput && emailInput.value.trim() || __lbdbUserEmail || '';
            _context2.p = 2;
            _context2.n = 3;
            return fetch("".concat(API_BASE, "/cancel/check"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                order_number: orderNumber,
                email: userEmail
              })
            });
          case 3:
            resp = _context2.v;
            _context2.n = 4;
            return resp.json();
          case 4:
            result = _context2.v;
            _cancelCheckCache = result;
            _renderCancelCheckResult(result);
            _context2.n = 6;
            break;
          case 5:
            _context2.p = 5;
            _t2 = _context2.v;
            body = document.getElementById('lbdb-cancel-modal-body');
            if (body) body.innerHTML = "\n        <div class=\"lcm-icon\">\u274C</div>\n        <h3 class=\"lcm-title\">".concat(T('cancel_error_connection'), "</h3>\n        <p class=\"lcm-text\">").concat(T('cancel_error_connection_text'), "</p>\n        <div class=\"lcm-actions\">\n          <a href=\"/pages/contact\" class=\"lcm-btn-primary\">").concat(T('cancel_contact'), "</a>\n          <button class=\"lcm-btn-secondary\" id=\"lcm-close-btn3\">").concat(T('cancel_close'), "</button>\n        </div>");
            cb = document.getElementById('lcm-close-btn3');
            if (cb) cb.addEventListener('click', closeCancelModal);
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[2, 5]]);
    }));
    return _checkCancellable.apply(this, arguments);
  }
  function confirmCancel() {
    return _confirmCancel.apply(this, arguments);
  }
  /* ---- Rendu résultats ---- */
  function _confirmCancel() {
    _confirmCancel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var data, orderNumber, userEmail, body, resp, result, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            data = _cancelData;
            if (data) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            orderNumber = data.order_number || '';
            userEmail = emailInput && emailInput.value.trim() || __lbdbUserEmail || '';
            body = document.getElementById('lbdb-cancel-modal-body');
            if (body) body.innerHTML = "\n      <div class=\"lcm-icon\">\u23F3</div>\n      <h3 class=\"lcm-title\">".concat(T('cancel_processing'), "</h3>\n      <p class=\"lcm-text\">").concat(T('cancel_processing_text'), "</p>");
            _context3.p = 2;
            _context3.n = 3;
            return fetch("".concat(API_BASE, "/cancel/confirm"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                order_number: orderNumber,
                email: userEmail
              })
            });
          case 3:
            resp = _context3.v;
            _context3.n = 4;
            return resp.json();
          case 4:
            result = _context3.v;
            if (result.success) {
              trackUiEvent('cancel_success', data, "amount=".concat(result.amount));
              body.innerHTML = "\n          <div class=\"lcm-icon\">\u2705</div>\n          <h3 class=\"lcm-title\">".concat(T('cancel_success'), "</h3>\n          <p class=\"lcm-text\">").concat(T('cancel_success_text', {
                order: esc(orderNumber),
                amount: esc(result.amount),
                currency: esc(result.currency || 'EUR')
              }), "</p>\n          <div class=\"lcm-actions\">\n            <button class=\"lcm-btn-primary\" id=\"lcm-done-btn\">").concat(T('cancel_close'), "</button>\n          </div>");
              document.getElementById('lcm-done-btn').addEventListener('click', closeCancelModal);
            } else {
              trackUiEvent('cancel_failed', data, "reason=".concat(result.reason || 'unknown'));
              body.innerHTML = "\n          <div class=\"lcm-icon\">\u274C</div>\n          <h3 class=\"lcm-title\">".concat(T('cancel_failed'), "</h3>\n          <p class=\"lcm-text\">").concat(T('cancel_failed_text'), "</p>\n          <div class=\"lcm-actions\">\n            <a href=\"/pages/contact\" class=\"lcm-btn-primary\">").concat(T('cancel_contact'), "</a>\n            <button class=\"lcm-btn-secondary\" id=\"lcm-close-btn4\">").concat(T('cancel_close'), "</button>\n          </div>");
              document.getElementById('lcm-close-btn4').addEventListener('click', closeCancelModal);
            }
            _context3.n = 6;
            break;
          case 5:
            _context3.p = 5;
            _t3 = _context3.v;
            trackUiEvent('cancel_error', data, "error=".concat(_t3.message || 'network'));
            body.innerHTML = "\n        <div class=\"lcm-icon\">\u274C</div>\n        <h3 class=\"lcm-title\">".concat(T('cancel_error_connection'), "</h3>\n        <p class=\"lcm-text\">").concat(T('cancel_error_finalize'), "</p>\n        <div class=\"lcm-actions\">\n          <a href=\"/pages/contact\" class=\"lcm-btn-primary\">").concat(T('cancel_contact'), "</a>\n          <button class=\"lcm-btn-secondary\" id=\"lcm-close-btn5\">").concat(T('cancel_close'), "</button>\n        </div>");
            document.getElementById('lcm-close-btn5').addEventListener('click', closeCancelModal);
          case 6:
            return _context3.a(2);
        }
      }, _callee3, null, [[2, 5]]);
    }));
    return _confirmCancel.apply(this, arguments);
  }
  function renderResult(data) {
    authSection.style.display = 'none';
    resultSection.style.display = 'block';
    if (magicBanner && window.__lbdbMagicToken) {
      magicBanner.textContent = T('magic_banner');
      magicBanner.style.display = 'block';
    }
    var currentStep = computeCurrentStep(data);
    renderHeroCard(data, currentStep);
    renderSteps(currentStep, data);

    /* Pré-vérification silencieuse si état restock ou priority */
    if (data.pre_shipment_state && ['restock', 'priority'].includes(data.pre_shipment_state)) {
      _cancelCheckCache = null;
      setTimeout(function () {
        return prefetchCancelCheck(data);
      }, 800);
    }

    /* Dernière mise à jour — style enhanced avec pastille verte */
    var lastUpdateEl = document.getElementById('lbdb-last-update');
    var lastUpdateText = document.getElementById('lbdb-last-update-text');
    if (lastUpdateEl && lastUpdateText && data.checkpoints && data.checkpoints.length) {
      var last = data.checkpoints[0];
      if (last && last.date) {
        var d = new Date(last.date);
        var diff = Math.round((Date.now() - d.getTime()) / 3600000);
        var label;
        if (diff < 1) {
          label = T('last_update_less_1h');
        } else if (diff < 24) {
          label = T('last_update_hours', {
            n: diff
          });
        } else {
          label = T('last_update_date') + ' ' + d.toLocaleDateString(getLocaleDate(), {
            day: 'numeric',
            month: 'short'
          });
        }
        lastUpdateText.textContent = T('last_update') + ' ' + label;
        lastUpdateEl.style.display = 'flex';
      }
    }

    /* Bloc info unifié : patience + benchmark + cs-info */
    var infoCard = document.getElementById('lbdb-info-card');
    if (infoCard && data.delivery_status !== 'delivered') {
      var nextScanEl = document.getElementById('lbdb-patience-next-scan');
      var benchmarkEl = document.getElementById('lbdb-patience-benchmark');
      var csEl = document.getElementById('lbdb-info-cs');

      // Helper : formater un nombre avec la décimale locale (virgule FR/DE/ES/IT/NL/PT/PL/EL/RO/SE/DK/NO, point EN)
      function fmtNum(n) {
        var loc = getLocaleDate();
        if (loc === 'en-GB' || loc === 'en-US') return String(n);
        return String(n).replace('.', ',');
      }

      // Motifs contextuels par step (neutres, sans mention de Chine)
      function getScanReason(step) {
        if (step >= 5 && step <= 6) return T('patience_reason_flight') || '';
        if (step === 7 || step === 8) return T('patience_reason_hub') || '';
        if (step >= 9) return T('patience_reason_local') || '';
        return '';
      }

      // Ligne 1 : prochain scan attendu
      if (nextScanEl && data.patience_data && data.patience_data.next_scan && data.patience_data.next_scan.next_scan_iso) {
        var pd = data.patience_data;
        var currentStep = computeCurrentStep(data);
        var nsDate = new Date(pd.next_scan.next_scan_iso);
        var nsLabel;
        var hoursUntil = pd.next_scan.hours_until_next || 0;
        var reason = getScanReason(currentStep);
        var reasonSuffix = reason ? ' \u2014 ' + reason : '';

        if (pd.next_scan.is_overdue) {
          // Ne pas déduire la fréquence d'un scan retardé du taux de livraison à temps.
          nsLabel = '';
        } else if (hoursUntil <= 6) {
          nsLabel = (T('patience_scan_hours') || 'Prochaine mise \u00e0 jour attendue dans les prochaines heures.') + reasonSuffix;
        } else {
          var dayName = nsDate.toLocaleDateString(getLocaleDate(), { weekday: 'long' });
          nsLabel = (T('patience_scan_day') || 'Prochaine mise \u00e0 jour attendue d\u2019ici {day} soir.').replace('{day}', dayName) + reasonSuffix;
        }
        nextScanEl.innerHTML = nsLabel ? '<span class="info-icon">\u23F0</span> <span>' + nsLabel + '</span>' : '';
      } else if (nextScanEl) {
        nextScanEl.innerHTML = '';
      }

      // Ligne 2 : benchmark social (décimale locale)
      if (benchmarkEl && data.patience_data && data.patience_data.benchmark &&
          data.patience_data.benchmark.source === 'database' &&
          data.patience_data.benchmark.sample_size >= 5 &&
          typeof data.patience_data.benchmark.avg_days === 'number' &&
          data.patience_data.days_in_transit > 0) {
        var pd2 = data.patience_data;
        var avgDays = fmtNum(pd2.benchmark.avg_days);
        var daysInTransit = Math.round(pd2.days_in_transit);
        var bmText = (T('patience_benchmark') || 'Les commandes arrivent en moyenne en {avg} jours. La v\u00f4tre est en route depuis {days} jours.')
          .replace('{avg}', '<strong>' + avgDays + '</strong>').replace('{days}', '<strong>' + daysInTransit + '</strong>');
        benchmarkEl.innerHTML = '<span class="info-icon">\uD83D\uDCCA</span> <span>' + bmText + '</span>';
      } else if (benchmarkEl) {
        benchmarkEl.innerHTML = '';
      }

      // Ligne 3 : info service client (discrète, en gris)
      if (csEl) {
        csEl.innerHTML = '<span class="info-icon">\u2139\uFE0F</span> <span>' + T('cs_same_info') + '</span>';
      }

      infoCard.style.display = 'flex';
    } else if (infoCard) {
      infoCard.style.display = 'none';
    }

    /* Numéro de suivi transporteur local */
    var tnCard = document.getElementById('lbdb-tracking-number-card');
    if (tnCard && data.show_tracking_number && data.tracking_number) {
      var tnTitle = tnCard.querySelector('.tn-title');
      var tnNum = tnCard.querySelector('.tn-number');
      var tnLink = tnCard.querySelector('.lbdb-btn-carrier');
      if (tnTitle) tnTitle.textContent = T('tracking_number_title');
      if (tnNum) tnNum.textContent = data.tracking_number;
      if (tnLink) {
        tnLink.textContent = T('tracking_btn');
        if (data.carrier_tracking_url) {
          tnLink.href = data.carrier_tracking_url;
        }
      }
      tnCard.style.display = 'block';
    }

    /* #13: FAQ contextuelle */
    var faqWrap = document.getElementById('lbdb-faq');
    var faqItems = document.getElementById('lbdb-faq-items');
    if (faqWrap && faqItems && data.delivery_status !== 'delivered' && currentStep >= 3) {
      var faqTitle = document.querySelector('.lbdb-faq-title');
      if (faqTitle) faqTitle.textContent = T('faq_title');
      var faqHtml = '';
      for (var qi = 1; qi <= 3; qi++) {
        var q = T('faq_q' + qi);
        var a = T('faq_a' + qi);
        if (q && q !== 'faq_q' + qi) {
          faqHtml += '<details class="lbdb-faq-item"><summary>' + q + '</summary><p>' + a + '</p></details>';
        }
      }
      /* Q4 conditionnelle : annulation impossible une fois expédié (step >= 3) */
      if (currentStep >= 3) {
        var q4 = T('faq_q4');
        var a4 = T('faq_a4');
        if (q4 && q4 !== 'faq_q4') {
          faqHtml += '<details class="lbdb-faq-item"><summary>' + q4 + '</summary><p>' + a4 + '</p></details>';
        }
      }

      faqItems.innerHTML = faqHtml;
      faqWrap.style.display = 'block';
    } else if (faqWrap) {
      faqWrap.style.display = 'none';
    }

    /* Bouton "Demande de retour" — uniquement si livrée */
    var returnBtnWrap = document.getElementById('lbdb-return-btn-wrap');
    if (returnBtnWrap) {
      returnBtnWrap.style.display = data.delivery_status === 'delivered' ? 'block' : 'none';
    }
  }

  /* ---- Appels API ---- */
  function fetchTracking(email, orderNumber) {
    setLoading(true);
    hideError();
    return fetchJson("".concat(API_BASE, "/api/auth"), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email,
        order_number: orderNumber
      })
    }).then(function (data) {
      assertTrackingPayload(data);
      __lbdbUserEmail = email;
      renderResult(data);
    })["catch"](function (error) {
      showError(error && error.publicMessage || T('error_network'));
    }).then(function () {
      setLoading(false);
    });
  }

  function fetchByToken(token) {
    setLoading(true);
    hideError();
    return fetchJson("".concat(API_BASE, "/api/track-by-token?token=").concat(encodeURIComponent(token))).then(function (data) {
      assertTrackingPayload(data);
      window.__lbdbMagicToken = true;
      // Stocker l'email depuis le payload du token (décodé en base64)
      try {
        var payloadB64 = token.split('.')[0];
        var decoded = JSON.parse(atob(payloadB64.replace(/-/g, '+').replace(/_/g, '/')));
        if (decoded.email) __lbdbUserEmail = decoded.email;
      } catch (error) {
        // Le backend reste l'unique autorité sur la validité du jeton.
      }
      renderResult(data);
    })["catch"](function (error) {
      showError(error && error.publicMessage || T('error_network'));
    }).then(function () {
      setLoading(false);
    });
  }
  /* ---- Événements ---- */
  if (submitBtn) {
    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var email = emailInput ? emailInput.value.trim() : '';
      var order = orderInput ? orderInput.value.trim() : '';
      if (!email || !order) {
        showError(T('error_invalid'));
        return;
      }
      fetchTracking(email, order);
    });
  }
  [emailInput, orderInput].forEach(function (el) {
    if (el) el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') submitBtn && submitBtn.click();
    });
  });

  // Bouton "Demande de retour" — affiché uniquement quand la commande est livrée
  // (la logique d'affichage est dans renderResult via data.delivery_status)

  /* ---- Init : token URL ou accès direct par ID ---- */
  var params = new URLSearchParams(window.location.search);
  var token = params.get('token');
  var directId = params.get('id');
  var directNumber = params.get('number');
  if (token) {
    fetchByToken(token);
  } else if (directId && directNumber) {
    // Accès direct Klaviyo : ?id=XXX&number=LBDBYYY
    authSection.style.display = 'none';
    resultSection.style.display = 'block';
    setLoading(true);
    fetchJson(API_BASE + '/api/track-by-id?id=' + encodeURIComponent(directId) + '&number=' + encodeURIComponent(directNumber)).then(function (data) {
      assertTrackingPayload(data);
      renderResult(data);
    })["catch"](function (error) {
      var directError = error && error.status >= 400 && error.status < 500 ? T('error_token') : T('error_network');
      showResultError(directError);
    })["finally"](function () {
      setLoading(false);
    });
  } else if (params.has('id') || params.has('number') || params.has('token')) {
    // Paramètres présents mais vides → lien invalide (Klaviyo mal configuré, etc.)
    authSection.style.display = 'none';
    resultSection.style.display = 'block';
    showResultError(T('error_token'));
  } else {
    // Support accès direct via ?email=X&order=Y (macros Gorgias, emails, etc.)
    var _urlEmail = params.get('email');
    var _urlOrder = params.get('order');
    if (_urlEmail && _urlOrder) {
      if (emailInput) emailInput.value = _urlEmail;
      if (orderInput) orderInput.value = _urlOrder;
      fetchTracking(_urlEmail, _urlOrder);
    }
  }
})();
